<template>
  <div class="buyerShop">
    <el-row :gutter="20">
      <el-col :xs="24" :sm="24" :md="20" :lg="14" :xl="10">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="200px">
          <h2>
            {{ $t('crm.vendorInfo') }}
            <div class="btn-group">
              <el-button size="small" type="primary" @click="pwdSetDialogVisible = true, newPass= ''">重置密码</el-button>
            </div>
          </h2>
          <el-form-item :label="$t('crm.vendorName')" v-if="showVendorName" prop="vendorName">
            <el-input disabled v-model="ruleForm.vendorName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('crm.vendorAlias')" prop="vendorAlias">
            <el-input disabled v-model="ruleForm.vendorNameAlias"></el-input>
          </el-form-item>
          <el-form-item :label="$t('crm.vendorType')" prop="vendorConfigurationVo.vendorType">
            <el-select disabled v-model="ruleForm.vendorConfigurationVo.vendorType">
              <el-option v-for="item in vendorTypeList" :label="item.desc" :value="item.value"
                          :key="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="+ruleForm.vendorConfigurationVo.vendorType ===5" :label="$t('crm.personalSellerIMID')" prop="vendorConfigurationVo.userAppId">
            <el-input disabled v-model="ruleForm.vendorConfigurationVo.userAppId"></el-input>
          </el-form-item>
          <el-form-item :label="$t('crm.vendorGeography')" prop="vendorConfigurationVo.addressCountryId">
            <el-select disabled v-model="ruleForm.vendorConfigurationVo.addressCountryId" filterable
                        :placeholder="$t('common.country')">
              <el-option v-for="item in countryList" :label="item.name" :value="item.addressCountryId"
                          :key="item.addressCountryId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('crm.currency')" prop="vendorConfigurationVo.originalPriceUnit">
            <el-select disabled v-model="ruleForm.vendorConfigurationVo.originalPriceUnit" filterable
                        :placeholder="$t('crm.currency')">
              <el-option v-for="item in unitList" :label="item.fromCountry" :value="item.fromCountry"
                          :key="item.productExchangeRateId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('crm.retailPriceIncludesTax')" prop="vendorConfigurationVo.retailPriceIncludingTax">
            <el-radio-group disabled v-model="ruleForm.vendorConfigurationVo.retailPriceIncludingTax">
              <el-radio :label="1">{{ $t('crm.taxIncluded') }}</el-radio>
              <el-radio :label="2">{{ $t('crm.taxExcluded') }}</el-radio>
            </el-radio-group>
            <span class="handling" v-if="update_retail_price_tax">处理中</span>
            <span class="send-email" v-else @click="sendEmail('update_retail_price_tax', $t('crm.retailPriceIncludesTax'))">发起邮件申请修改</span>
          </el-form-item>
          <el-form-item :label="$t('crm.pricingConnectivityMethod')"
                        prop="vendorConfigurationVo.supplyPriceMethod">
            <el-radio-group disabled v-model="ruleForm.vendorConfigurationVo.supplyPriceMethod">
              <el-radio v-for="item in supplyPriceMethod" :label="+item.dictCode" :key="item.dictCode">
                {{ item.dictValue }}
              </el-radio>
            </el-radio-group>
            <span class="handling" v-if="update_supply_method">处理中</span>
            <span class="send-email" v-else @click="sendEmail('update_supply_method', $t('crm.pricingConnectivityMethod'))">发起邮件申请修改</span>
          </el-form-item>
          <el-form-item v-if="ruleForm.vendorConfigurationVo.supplyPriceMethod == 1" :label="$t('crm.supplyPriceIncludesTax')" prop="vendorConfigurationVo.includingTax">
            <el-radio-group disabled v-model="ruleForm.vendorConfigurationVo.includingTax">
              <el-radio :label="1">{{ $t('crm.taxIncluded') }}</el-radio>
              <el-radio :label="2">{{ $t('crm.taxExcluded') }}</el-radio>
            </el-radio-group>
            <span class="handling" v-if="update_supply_price_tax">处理中</span>
            <span class="send-email" v-else @click="sendEmail('update_supply_price_tax', $t('crm.supplyPriceIncludesTax'))">发起邮件申请修改</span>
          </el-form-item>
          <el-form-item v-if="ruleForm.vendorConfigurationVo.supplyPriceMethod == 2" :label="$t('crm.provideHangingPrice')" prop="vendorConfigurationVo.provideRetailPrice">
            <el-radio-group disabled v-model="ruleForm.vendorConfigurationVo.provideRetailPrice">
              <el-radio :label="1">{{ $t('common.yes') }}</el-radio>
              <el-radio :label="2">{{ $t('common.no') }}</el-radio>
            </el-radio-group>
            <span class="handling" v-if="update_provide_retail_price">处理中</span>
            <span class="send-email" v-else @click="sendEmail('update_provide_retail_price', $t('crm.provideHangingPrice'))">发起邮件申请修改</span>
          </el-form-item>
          <el-form-item :label="$t('crm.preSaleAvailablity')" prop="vendorConfigurationVo.isPerSale">
            <el-radio-group v-model="ruleForm.vendorConfigurationVo.isPerSale" :disabled="ruleForm.vendorConfigurationVo.wholesaleType == 1 ? false : true">
              <el-radio :label="1">{{ $t('crm.support') }}</el-radio>
              <el-radio :label="2">{{ $t('crm.notSupport') }}</el-radio>
              <el-radio :label="3">{{ $t('crm.rollingPreSale') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('crm.contractOrSLASigned')" prop="vendorConfigurationVo.isSignSla">
            <el-radio-group v-model="ruleForm.vendorConfigurationVo.isSignSla">
              <el-radio :label="2">{{ $t('common.yes') }}</el-radio>
              <el-radio :label="1">{{ $t('common.no') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="货单类型" prop="wholesaleType" v-if="ruleForm.vendorConfigurationVo.vendorType == 7">
            <el-radio-group v-model="ruleForm.vendorConfigurationVo.wholesaleType" disabled>
              <el-radio :label="1">现货货单</el-radio>
              <el-radio :label="4">品牌补货</el-radio>
              <el-radio :label="5">期货预售</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="ruleForm.vendorConfigurationVo.isSignSla === 2" :label="$t('crm.contractTime')" prop="vendorConfigurationVo.signSlaTime">
            <el-date-picker
                v-model="ruleForm.vendorConfigurationVo.signSlaTime"
                type="date"
                :editable="false"
                :clearable="false"
                value-format="timestamp"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('crm.imRepresentative')" prop="vendorConfigurationVo.boutiqueBdId">
            <el-select v-model="ruleForm.vendorConfigurationVo.boutiqueBdId" @change="changeBoutiqueBdId" filterable>
              <el-option v-for="item in boutiqueBdList" :label="item.label" :value="item.value"
                          :key="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('crm.imAssistantRepresentative')"
                        prop="vendorConfigurationVo.boutiqueAssistantId">
            <el-select v-model="ruleForm.vendorConfigurationVo.boutiqueAssistantId" @change="changeBoutiqueAssistantId" filterable>
              <el-option v-for="item in boutiqueBdList" :label="item.label" :value="item.value"
                          :key="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('crm.vendorRegion')" prop="vendorConfigurationVo.businessRegionId">
            <el-select v-model="ruleForm.vendorConfigurationVo.businessRegionId" @change="changeBusinessRegionId">
              <el-option v-for="item in businessRegionList" :label="item.label" :value="item.value"
                          :key="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="`${$t('crm.parentCompanyName')}(${$t('crm.businessEntityName')})`"
                        prop="vendorExtReqVo.groupName">
            <el-autocomplete v-model="ruleForm.vendorExtReqVo.groupName" value-key="groupName"
                              :fetch-suggestions="querySearch"></el-autocomplete>
          </el-form-item>
<!--              <el-form-item :label="$t('crm.ifIMCanGetTaxBack')" prop="vendorConfigurationVo.drawback">-->
<!--                <el-select v-model="ruleForm.vendorExtReqVo.drawback">-->
<!--                  <el-option :label="$t('common.yes')" :value="1"></el-option>-->
<!--                  <el-option :label="$t('common.no')" :value="0"></el-option>-->
<!--                </el-select>-->
<!--              </el-form-item>-->
          <!-- <el-form-item :label="$t('crm.deadlineForDay')" prop="vendorExtReqVo.cutOffTime">
            <el-time-picker
                value-format="HH:mm"
                format="HH:mm"
                v-model="ruleForm.vendorExtReqVo.cutOffTime"
                :clearable="false"
                style="width: 100%"
            ></el-time-picker>
          </el-form-item> -->
          <!-- <el-form-item :label="$t('crm.confirmTimeFromMerchant')" prop="vendorExtReqVo.latestConfirmDay">
            <el-row :gutter="0">
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-select v-model="ruleForm.vendorExtReqVo.latestConfirmDay">
                  <el-option v-for="(item, index) in 31" :key="item" :label="'T+'+index" :value="index + ''"></el-option>
                </el-select>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-time-picker
                    value-format="HH:mm"
                    format="HH:mm"
                    v-model="ruleForm.vendorExtReqVo.latestConfirmTime"
                    :clearable="false"
                    style="width: 100%"
                ></el-time-picker>
              </el-col>
            </el-row>
          </el-form-item> -->
          <!-- <el-form-item :label="$t('crm.shippingDeadline')" prop="vendorExtReqVo.latestDeliveryDay">
            <el-row :gutter="0">
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-select v-model="ruleForm.vendorExtReqVo.latestDeliveryDay">
                  <el-option v-for="(item, index) in 31" :key="item" :label="'T+'+index" :value="index + ''"></el-option>
                </el-select>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-time-picker
                    value-format="HH:mm"
                    format="HH:mm"
                    v-model="ruleForm.vendorExtReqVo.latestDeliveryTime"
                    :clearable="false"
                    style="width: 100%"
                ></el-time-picker>
              </el-col>
            </el-row>
          </el-form-item> -->
          <!-- <el-form-item :label="$t('crm.orderShippingDay')" prop="vendorExtReqVo.deliveryTime">
            <el-select v-model="ruleForm.vendorExtReqVo.deliveryTime" multiple>
              <el-option v-for="(item, index) in 7" :key="index" :label="$t(`common.week${index}`)" :value="item + ''"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item :label="$t('crm.operationType')" prop="vendorConfigurationVo.operationType">
            <el-select v-model="ruleForm.vendorConfigurationVo.operationType">
              <el-option v-for="item in vendorOperationType" :label="item.dictValue" :value="item.dictCode" :key="item.dictCode"></el-option>
            </el-select>
          </el-form-item>
        </el-form>

        <div class="stock-location mt30">
          <h2>stock location</h2>
          <div class="tr mb10">
            <el-button type="primary" :disabled="disabledAddStocklocation" @click="onClickAdd">{{ $t('common.add') }}</el-button>
          </div>
          <el-collapse v-model="activeName" accordion>
            <el-collapse-item :name="'collapse' + item.key" v-for="(item, index) in this.ruleForm.stockLocationResVos" :key="item.key">
              <template slot="title">
                <div class="title">
                  <span class="name">{{ $t('common.name') }}：{{item.stockLocation}}</span>
                  <span class="status">{{ $t('common.status') }}：{{item.state === 1 ? $t('crm.using') : $t('crm.terminated') }}</span>
                  <div class="right">
                    <el-button type="text" @click="clickEdit($event, item)">{{ $t('common.edit') }}</el-button>
                    <el-button type="text" v-if="item.state === 1" @click.stop="setState(item, 2)">{{ $t('common.disable') }}</el-button>
                    <el-button type="text" v-else @click.stop="setState(item, 1)">{{ $t('common.open') }}</el-button>
                  </div>
                </div>
              </template>
              <el-form :ref="'form' + item.key" class="searchForm pl20" :model="item" label-position="top" size="small">
                <el-row :gutter="20">
                  <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                    <el-form-item class="mb10" :label="$t('common.stockLocation2')" prop="stockLocation"
                                  :rules="[{ required: true, message: `${$t('common.plzInput')}${$t('common.stockLocation2')}` }]">
                      <el-input v-if="item.editFormStatus" v-model="item.stockLocation"></el-input>
                      <span v-else>{{ item.stockLocation }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                    <el-form-item class="mb10" :label="$t('crm.shipFromStockLocation')" prop="shipFromLocationId"
                                  :rules="[{ required: true, message: `${$t('common.plzSelect')}${$t('crm.shipFromStockLocation')}` }]">
                      <el-select v-if="item.editFormStatus" v-model="item.shipFromLocationId">
                        <el-option label="self" v-if="!item.locationId" :value="-1"></el-option>
                        <el-option v-for="(si, index) in comboList" :key="index" :label="si.stockLocation" :value="si.locationId"></el-option>
                      </el-select>
                      <span v-else>{{ comboMap[item.shipFromLocationId] }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                    <el-form-item class="mb10" :label="$t('crm.registeredCompanyName')" prop="contactCompanyName"
                                  :rules="[{ required: true, message: `${$t('common.plzInput')}${$t('crm.registeredCompanyName')}` }]">
                      <el-input v-if="item.editFormStatus" v-model="item.contactCompanyName"></el-input>
                      <span v-else>{{ item.contactCompanyName }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                    <el-form-item class="mb10" :label="$t('crm.contactPerson')" prop="contactPersonName"
                                  :rules="[{ required: true, message: `${$t('common.plzInput')}${$t('crm.contactPerson')}` }]">
                      <el-input v-if="item.editFormStatus" v-model="item.contactPersonName"></el-input>
                      <span v-else>{{ item.contactPersonName }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                    <el-form-item class="mb10" :label="$t('crm.contactEmail')" prop="contactEmailAddress"
                      :rules="[
                        { required: true, message: `${$t('common.plzInput')}${$t('crm.contactEmail')}` },
                        { pattern: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/, message: $t('crm.emailFormatIncorrect'), trigger: 'blur' }
                      ]"
                    >
                      <el-input v-if="item.editFormStatus" v-model="item.contactEmailAddress"></el-input>
                      <span v-else>{{ item.contactEmailAddress }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                    <el-form-item class="mb10" :label="$t('crm.contactPhoneNumber')" prop="contactPhoneNumber"
                                  :rules="[{ required: true, message: `${$t('common.plzInput')}${$t('crm.contactPhoneNumber')}` }]">
                      <div class="area-mobile" v-if="item.editFormStatus">
                        <el-input class="area-code" v-model="item.areaCode" placeholder="区号" maxlength="4"></el-input>
                        <el-input v-model="item.contactPhoneNumber"></el-input>
                      </div>
                      <span v-else>{{ item.areaCode ? '+' + item.areaCode : '' }} {{ item.contactPhoneNumber }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                    <el-form-item class="mb10" :label="$t('common.country')" prop="addressCountryCode"
                                  :rules="[{ required: true, message: `${$t('common.plzSelect')}${$t('crm.country')}` }]">
                      <el-select v-if="item.editFormStatus" v-model="item.addressCountryCode"
                                  @change="() => onchangeCountry(item)">
                        <el-option v-for="item in countryList" :key="item.countryCode + item.addressCountryId" :label="item.name" :value="item.countryCode"></el-option>
                      </el-select>
                      <span v-else>{{ countryListMap[item.addressCountryCode] }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                    <el-form-item class="mb10" :label="$t('common.city')" prop="addressCity"
                                  :rules="[{ required: true, message: `${$t('common.plzEnterSelect')}${$t('common.city')}` }]">
                      <el-select
                          v-if="item.editFormStatus"
                          v-model="item.addressCity"
                          filterable
                          remote
                          reserve-keyword
                          :remote-method="(query) => remoteMethod(query, item)"
                      >
                        <el-option v-for="item in cityList" :key="item.cityName" :label="item.cityName"
                                    :value="item.cityName"></el-option>
                      </el-select>
                      <span v-else>{{ item.addressCity }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                    <el-form-item class="mb10" :label="$t('common.postCode')" prop="addressPostalCode"
                                  :rules="[{ required: true, message: `${$t('common.plzInput')}${$t('common.postCode')}` }]">
                      <el-input v-if="item.editFormStatus" v-model="item.addressPostalCode"></el-input>
                      <span v-else>{{ item.addressPostalCode }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                    <el-form-item class="mb10" :label="$t('common.address') + '1'" prop="addressStreetLines"
                                  :rules="[{ required: true, message: `${$t('common.plzInput')}${$t('crm.address')}1` },{validator: (rule, value, callback) => checkAddressLength(rule, value, callback, item)}]">
                      <el-input v-if="item.editFormStatus" v-model="item.addressStreetLines" :maxlength="45"></el-input>
                      <span v-else>{{ item.addressStreetLines }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                    <el-form-item class="mb10" :label="$t('common.address') + '2'" prop="addressStreetLines2">
                      <el-input v-if="item.editFormStatus" v-model="item.addressStreetLines2" @input="onInputAddress('form' + item.key)" :maxlength="45"></el-input>
                      <span v-else>{{ item.addressStreetLines2 }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                    <el-form-item class="mb10" :label="$t('common.address') + '3'" prop="addressStreetLines3">
                      <el-input v-if="item.editFormStatus" v-model="item.addressStreetLines3" @input="onInputAddress('form' + item.key)" :maxlength="45"></el-input>
                      <span v-else>{{ item.addressStreetLines3 }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8" v-if="item.editFormStatus">
                    <el-form-item class="mb10" label=" " v-if="item.locationId">
                      <el-button type="primary" @click="update(item)">{{ $t('common.save') }}</el-button>
                      <el-button @click="onClickCancel(index)">{{ $t('common.cancel') }}</el-button>
                    </el-form-item>
                    <el-form-item class="mb10" label=" " v-else>
                      <el-button type="primary" @click="create(item)">{{ $t('common.save') }}</el-button>
                      <el-button @click="ruleForm.stockLocationResVos.shift()">{{ $t('common.cancel') }}</el-button>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </el-collapse-item>
          </el-collapse>
        </div>
        <div class="email mt30">
          <h2>{{ $t('crm.afterSaleNotifyEmail') }}</h2>
          <div class="mt10 mb20">
            <el-input v-model="input" style="width: 200px;margin-right: 10px" size="medium"
                      placeholder="请输入内容"></el-input>
            <el-button type="primary" icon="el-icon-plus" size="medium" :disabled="!input" @click="submitEmail"
                        circle></el-button>
          </div>
          <div class="email-item" v-for="(item, index) in ruleForm.vendorConfigurationVo.boutiqueAftermarketEmail" :key="item + index">{{ item }}
            <i @click="onClickRemove(item)" class="icon-close el-icon-circle-close"></i>
          </div>
        </div>

        <h2 class="mt30">{{ $t('crm.workOrderAutoEmailSettings') }}</h2>
        <div class="level-list">
          <el-checkbox-group v-model="ruleForm.mailDefectLevelValueArr" @change="changeCheckList">
            <el-checkbox disabled>L0</el-checkbox>
            <el-checkbox disabled>L1</el-checkbox>
            <el-checkbox v-for="(item, index) in levelList" :key="index" :label="item.labelName">{{ item.labelName }}</el-checkbox>
          </el-checkbox-group>
        </div>

        <h2 class="mt30">{{ $t('crm.vendorOrderPushEmail') }}</h2>
        <el-table :data="orderNotificationEmailVos2" :header-cell-style="{backgroundColor: '#f0f0f0'}" border>
          <el-table-column :label="$t('common.email')">
            <template slot-scope="scope">
              <p v-for="(e, index) in scope.row.email.split(',')" :key="index">{{ e }}</p>
            </template>
          </el-table-column>
          <el-table-column :label="$t('crm.orderPushTime')">
            <template slot-scope="scope">
              <template v-if="scope.row.orderTime">
                <p v-for="(t, index) in scope.row.orderTime" :key="index">
                  {{ t.startTime }} ~ {{ t.endTime }} ({{ scope.row.timeZone }})
                </p>
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="emailContent" :label="$t('crm.pushEmailContent')">
            <template slot-scope="scope">
              {{emailContentMapFnc(scope.row.emailContent)}}
            </template>
          </el-table-column>
          <el-table-column :label="$t('common.action')">
            <template slot-scope="scope">
              <el-button type="text" @click="editPushEmail(scope)" size="mini">{{ $t('common.edit') }}</el-button>
              <el-button type="text" @click="removePushEmail(scope)" size="mini">{{ $t('common.remove') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-button class="mt10" type="text" @click="addPushEmail" size="mini">{{ $t('crm.addPushEmail') }}</el-button>
        <el-dialog :title="$t('crm.orderNotifyEmail')" :visible.sync="dialogVisiblePushEmail" width="700px" :close-on-click-modal="false">
          <p class="mb10">{{$t('common.email')}}</p>
          <el-input v-model="addContactValue" style="width: 200px" size="medium">
            <el-button v-if="addContactList.length < 10" @click="addContact" slot="append" icon="el-icon-circle-plus-outline"></el-button>
          </el-input>
          <span>{{ $t('crm.canInputEmailsMost') }}</span>
          <div class="push-email-group mt10">
            <div class="push-email-item" v-for="(item, index) in addContactList" :key="index">
              <i class="el-icon-close" @click="removeContact(item)"></i>
              {{ item }}
            </div>
          </div>

          <p class="mt20 mb10">
            {{ $t('crm.orderEmailTime') }}
            <el-tooltip
                effect="dark"
                content="The orders which is created in the following time will be send to the email"
                placement="top-start"
            >
              <i class="el-icon-question"></i>
            </el-tooltip>
            <span style="margin-left: 113px">{{ $t('crm.orderEmailTip2') }}</span>
          </p>
          <div class="push-email-group">
            <div class="push-email-item" v-for="(item, index) in orderTimeList" :key="index">
              <i class="el-icon-close" @click="deleteOrderList(item)"></i>
              {{ item.content }}
            </div>
          </div>
          <el-button type="text" v-if="orderTimeList.length < 5" @click="(editOrderTime = true),
          (weekStart = 'Sunday'),
          (timeStart = '00:00'),
          (weekEnd = 'Saturday'),
          (timeEnd = '23:59')" size="mini">+ {{ $t('crm.addTime') }}</el-button>

          <p class="mt20 mb10">{{ $t('crm.pushEmailContent') }}</p>
          <el-select size="medium" v-model="currTimeZone" style="width: 200px">
            <el-option v-for="item in timeZoneList" :key="item" :label="item" :value="item"></el-option>
          </el-select>

          <p class="mt20 mb10">{{ $t('crm.pushEmailContent') }}</p>
          <el-checkbox v-for="ct in contentTypeList" :key="ct.code" v-model="ct.checked">{{ ct.explain }}</el-checkbox>

          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisiblePushEmail = false">{{ $t('common.cancel') }}</el-button>
            <el-button type="primary" @click="submitPushEmail">{{ $t('common.ok') }}</el-button>
          </span>
        </el-dialog>
        <el-dialog :title="$t('crm.selectOrderTime')" :visible.sync="editOrderTime" width="600px" :close-on-click-modal="false">
          <el-select v-model="weekStart" style="width: 110px">
            <el-option v-for="item in weekList" :key="item" :value="item" :label="item"></el-option>
          </el-select>
          <el-time-picker
              value-format="HH:mm"
              format="HH:mm"
              v-model="timeStart"
              :clearable="false"
              style="width: 110px"
          ></el-time-picker>
          ~
          <el-select v-model="weekEnd" style="width: 110px">
            <el-option v-for="item in weekList" :key="item" :value="item" :label="item"></el-option>
          </el-select>
          <el-time-picker
              value-format="HH:mm"
              format="HH:mm"
              v-model="timeEnd"
              :clearable="false"
              style="width: 110px"
          ></el-time-picker>

          <span slot="footer" class="dialog-footer">
            <el-button @click="editOrderTime = false">{{ $t('common.cancel') }}</el-button>
            <el-button type="primary" @click="saveTimeZone">{{ $t('common.ok') }}</el-button>
          </span>
        </el-dialog>

        <el-form :model="ruleForm" :rules="rules" ref="ruleForm11" label-width="200px">
          <h2 class="mt30">{{ $t('crm.vendorEvaluation') }}</h2>
          <el-form-item :label="$t('crm.vendorsPartnership')">
            <el-input type="textarea" v-model="ruleForm.vendorExtReqVo.imDefinition"></el-input>
          </el-form-item>
          <el-form-item :label="$t('crm.mpSalesSatisfaction')">
            <el-select v-model="ruleForm.vendorExtReqVo.mpSalesSatisfaction">
              <el-option v-for="item in scoreList" :label="item.dictValue" :value="item.dictCode"
                         :key="item.dictCode"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('crm.salesSatisfaction')">
            <el-select v-model="ruleForm.vendorExtReqVo.wholesaleSalesSatisfaction">
              <el-option v-for="item in scoreList" :label="item.dictValue" :value="item.dictCode"
                         :key="item.dictCode"></el-option>
            </el-select>
          </el-form-item>

          <h2 class="mt30">{{ $t('crm.payment') }}</h2>
          <el-form-item :label="$t('crm.paymentMethod')" prop="paymentInfoReqVo.paymentMethod">
            <el-select v-model="ruleForm.paymentInfoReqVo.paymentMethod" @change="changePaymentMethod">
              <el-option v-for="item in paymentMethodList" :label="item.dictValue" :value="item.dictCode"
                         :key="item.dictCode"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('crm.depositAmount')" prop="paymentInfoReqVo.depositAmount" :rules="[{
            required: ruleForm.paymentInfoReqVo.paymentMethod === 'crm_pre_payment',
            message: `${this.$t('common.plzInput')}${this.$t('crm.depositAmount')}`
          }]">
            <el-input v-model="ruleForm.paymentInfoReqVo.depositAmount"></el-input>
          </el-form-item>
          <el-form-item :label="$t('crm.paymentTiming')" prop="paymentInfoReqVo.paymentTiming">
            <el-row>
              <el-col :span="ruleForm.paymentInfoReqVo.paymentTiming === 'crm_payment_others' ? 12 : 24">
                <el-select v-model="ruleForm.paymentInfoReqVo.paymentTiming" @change="changePaymentTiming">
                  <el-option v-for="item in paymentTimingList" :label="item.dictValue" :value="item.dictCode"
                             :key="item.dictCode"></el-option>
                </el-select>
              </el-col>
              <el-col :span="12" v-if="ruleForm.paymentInfoReqVo.paymentTiming === 'crm_payment_others'">
                <el-input v-model="ruleForm.paymentInfoReqVo.paymentTimingRemark"
                          :placeholder="$t('crm.otherPaymentTiming')"></el-input>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item :label="$t('crm.settlementCycle')" v-if="ruleForm.paymentInfoReqVo.paymentTiming === 'crm_payment_week'" prop="paymentInfoReqVo.paymentTimingTime">
            <el-select v-model="ruleForm.paymentInfoReqVo.paymentTimingTime">
              <el-option v-for="(item, index) in 7" :key="item" :label="$t(`common.week${index}`)" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('crm.paymentRemark')">
            <el-input v-model="ruleForm.paymentInfoReqVo.paymentMethodRemark"></el-input>
          </el-form-item>
          <el-form-item :label="$t('crm.vendorSettlementCurrency')">
            <el-select v-model="ruleForm.paymentInfoReqVo.settleCurrency" clearable>
              <el-option v-for="item in unitList" :label="item.fromCountry" :value="item.fromCountry"
                          :key="item.productExchangeRateId"></el-option>
            </el-select>
          </el-form-item>

          <!-- <h2 class="mt30">{{ $t('crm.pricingInfo') }}</h2>
          <el-form-item :label="$t('crm.ifIMCanGetTaxBack')" prop="vendorExtReqVo.drawback">
            <el-select v-model="ruleForm.vendorExtReqVo.drawback">
              <el-option :label="$t('crm.taxRefund')" :value="1"></el-option>
              <el-option :label="$t('crm.noTaxRefund')" :value="0"></el-option>
            </el-select>
          </el-form-item> -->

          <h2 class="mt30">{{ $t('crm.billingInfo') }}</h2>
          <el-form-item :label="$t('crm.companyName')" prop="invoiceReqVo.companyName" :rules="[{ required: Boolean(invoiceRequired), message: `${$t('common.plzInput')}${$t('crm.companyName')}` }]">
            <el-input v-model="ruleForm.invoiceReqVo.companyName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('crm.vatNumber')" prop="invoiceReqVo.businessLicenseNumber" :rules="[{ required: Boolean(invoiceRequired), message: `${$t('common.plzInput')}${$t('crm.vatNumber')}`}]">
            <el-input v-model="ruleForm.invoiceReqVo.businessLicenseNumber"></el-input>
          </el-form-item>
          <el-form-item :label="$t('crm.contactPerson')" prop="invoiceReqVo.contactPerson" :rules="[{ required: Boolean(invoiceRequired), message: `${$t('common.plzInput')}${$t('crm.contactPerson')}` }]">
            <el-input v-model="ruleForm.invoiceReqVo.contactPerson" :placeholder="$t('crm.contactPerson')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('crm.contactEmail')" prop="invoiceReqVo.contactEmail" :rules="[{ required: Boolean(invoiceRequired), message: `${$t('common.plzInput')}${$t('crm.contactEmail')}`}]">
            <el-input v-model="ruleForm.invoiceReqVo.contactEmail" :placeholder="$t('crm.contactEmail')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('crm.contactPhoneNumber')" prop="invoiceReqVo.contactPhone" :rules="[{ required: Boolean(invoiceRequired), message: `${$t('common.plzInput')}${$t('crm.contactPhoneNumber')}` }]">
            <el-input v-model="ruleForm.invoiceReqVo.contactPhone"
                      :placeholder="$t('crm.contactPhoneNumber')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('common.country')" prop="invoiceReqVo.addressCountryId" :rules="[{ required: Boolean(invoiceRequired), message: `${$t('common.plzInput')}${$t('common.country')}`}]">
            <el-select v-model="ruleForm.invoiceReqVo.addressCountryId" disabled filterable
                       :placeholder="$t('common.country')">
              <el-option v-for="item in countryList" :label="item.name" :value="item.addressCountryId"
                             :key="item.addressCountryId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('common.city')" prop="invoiceReqVo.city" :rules="[{required: Boolean(invoiceRequired), message: `${$t('common.plzInput')}${$t('common.city')}`}]">
            <el-select
                v-model="ruleForm.invoiceReqVo.city"
                filterable
                remote
                reserve-keyword
                placeholder="请输入关键词"
                :loading="cityLoading"
                :remote-method="remoteMethod2">
              <el-option v-for="item in cityList2" :key="item.cityName" :label="item.cityName" :value="item.cityName"></el-option>
            </el-select>

          </el-form-item>
          <el-form-item :label="$t('common.postCode')" prop="invoiceReqVo.postalCode" :rules="[{ required: Boolean(invoiceRequired), message: `${$t('common.plzInput')}${$t('common.postCode')}` }]">
            <el-input v-model="ruleForm.invoiceReqVo.postalCode" :placeholder="$t('common.postCode')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('common.address')" prop="invoiceReqVo.businessLicenseLocation" :rules="[{ required: Boolean(invoiceRequired), message: `${$t('common.plzInput')}${$t('common.address')}`}]">
            <el-input type="textarea" v-model="ruleForm.invoiceReqVo.businessLicenseLocation"
                      :placeholder="$t('common.address')"></el-input>
          </el-form-item>
        </el-form>

      </el-col>
    </el-row>

    <h2 class="mt30">{{ $t('crm.payeeInfo') }}</h2>
    <el-table :data="payeeInfoData2" :header-cell-style="{backgroundColor: '#f0f0f0'}" border>
      <el-table-column prop="payeeName" :label="$t('crm.payeeName')"></el-table-column>
      <el-table-column prop="bankOfName" :label="$t('crm.bankName')"></el-table-column>
      <el-table-column prop="bankAccountNo" :label="$t('crm.bankAccount')"></el-table-column>
      <el-table-column prop="bankAddress" :label="$t('crm.bankAddress')"></el-table-column>
      <el-table-column prop="swiftCode" :label="$t('crm.swiftCode')"></el-table-column>
      <el-table-column prop="iban" :label="$t('crm.iban')"></el-table-column>
      <el-table-column prop="payType" :label="$t('crm.payMethod')">
        <template slot-scope="scope">
            {{scope.row.payType==1?$t('crm.overseaPayment'):$t('crm.domesticPayment') }}
        </template>
      </el-table-column>
      <el-table-column prop="idNo" :label="$t('crm.idNumber')"></el-table-column>
      <el-table-column prop="phoneNum" :label="$t('crm.phoneNumber')"></el-table-column>
      <el-table-column prop="defaultOption" :label="$t('crm.defaultOption')">
        <template slot-scope="scope">{{scope.row.defaultOption === 1 ? $t('common.yes') : scope.row.defaultOption === 0 ? $t('common.no') : "" }}</template>
      </el-table-column>
      <el-table-column :label="$t('common.action')">
        <template slot-scope="scope">
          <el-button type="text" @click="editPayeeInfo(scope)" size="mini">
            {{ $t('common.edit') }}
          </el-button>
          <el-button type="text" v-if="payeeInfoData2.length > 1" @click="removePayeeInfo(scope)" size="mini">
            {{ $t('common.remove') }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-button type="text" @click="showDialogPayeeInfo">{{ $t('crm.addPayeeInfo') }}</el-button>
    <el-dialog :title="payeeInfoForm.vendorPaymentId ? $t('crm.editPayeeInfo') : $t('crm.addPayeeInfo')" :visible.sync="dialogVisiblePayeeInfo" width="500px"
               :close-on-click-modal="false">
      <el-form :model="payeeInfoForm" ref="payeeInfoForm" label-width="120px">
        <el-form-item :label="$t('crm.payeeName')" prop="payeeName"
                      :rules="[{ required: true, message: `${$t('common.plzInput')}${$t('crm.payeeName')}`  }]">
          <el-input v-model="payeeInfoForm.payeeName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm.bankName')" prop="bankOfName"
                      :rules="[{ required: true, message: `${$t('common.plzInput')}${$t('crm.bankName')}`  }]">
          <el-input v-model="payeeInfoForm.bankOfName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm.bankAccount')" prop="bankAccountNo"
                      :rules="[{ required: true, message: `${$t('common.plzInput')}${$t('crm.bankAccount')}`  }]">
          <el-input v-model="payeeInfoForm.bankAccountNo"></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm.bankAddress')" prop="bankAddress">
          <el-input v-model="payeeInfoForm.bankAddress"></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm.swiftCode')" prop="swiftCode"
                      :rules="payeeInfoForm.payType === 2 ? [] : [{ required: true, message: `${$t('common.plzInput')}${$t('crm.swiftCode')}`  }]">
          <el-input v-model="payeeInfoForm.swiftCode"></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm.iban')" prop="iban">
          <el-input v-model="payeeInfoForm.iban"></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm.idNumber')" prop="idNo">
          <el-input v-model="payeeInfoForm.idNo"></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm.payMethod')" prop="payType">
          <el-radio-group v-model="payeeInfoForm.payType">
            <el-radio :label="1">{{$t('crm.overseaPayment')}}</el-radio>
            <el-radio :label="2">{{$t('crm.domesticPayment') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('crm.phoneNumber')" prop="phoneNum">
          <el-input v-model="payeeInfoForm.phoneNum"></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm.defaultOption')" prop="defaultOption">
          <el-radio-group v-model="payeeInfoForm.defaultOption">
            <el-radio :label="1">{{$t('common.yes')}}</el-radio>
            <el-radio :label="0">{{$t('common.no') }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisiblePayeeInfo = false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="submitPayeeInfo">{{ $t('common.ok') }}</el-button>
      </span>
    </el-dialog>

    <h2 class="mt30">{{ $t('crm.vendorContacts') }}</h2>
    <el-table :data="vendorContactsInfoData2" :header-cell-style="{backgroundColor: '#f0f0f0'}" border>
      <el-table-column prop="contactName" :label="$t('crm.mainContactName')"></el-table-column>
      <el-table-column prop="contactTitle" :label="$t('crm.mainContactTitle')"></el-table-column>
      <el-table-column :label="$t('crm.mainContact')">
        <template slot-scope="scope">
          <template v-for="(item, index) in scope.row.contactList">
            <p class="mb5" v-if="item.enabled" :key="index">{{ contactTypeMap[item.contactType] }}: {{ item.contactNo }}</p>
          </template>
        </template>
      </el-table-column>
      <el-table-column :label="$t('crm.mainContactReponseSpeed')">
        <template slot-scope="scope">
          {{ scoreListMap[scope.row.contactResponseSpeed] }}
        </template>
      </el-table-column>
      <el-table-column prop="contactResponsibleFor" :label="$t('crm.mainContactResponsiblefor')">
        <template slot-scope="scope">
          {{ contactResponsibleForMap[scope.row.contactResponsibleFor] }}
        </template>
      </el-table-column>
      <el-table-column prop="contactNegotiationStyle" :label="$t('crm.mainContactNegotitationStyle')"></el-table-column>
      <el-table-column :label="$t('common.action')">
        <template slot-scope="scope">
          <el-button type="text" @click="editVendorContactsInfo(scope)"
                     size="mini">{{ $t('common.edit') }}
          </el-button>
          <el-button type="text" v-if="vendorContactsInfoData2.length > 1" @click="removeVendorContactsInfo(scope)"
                     size="mini">{{ $t('common.remove') }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-button type="text" @click="showVendorContactsInfo">{{ $t('crm.addVendorContact') }}</el-button>
    <el-dialog :title="vendorContactsInfoForm.vendorContactsId ? $t('crm.editVendorContact') : $t('crm.addVendorContact')" :visible.sync="dialogVisibleVendorContactsInfo" width="500px"
               :close-on-click-modal="false">
      <el-form :model="vendorContactsInfoForm" ref="vendorContactsInfoForm" label-width="120px">
        <h3>{{ $t('crm.basicInfo') }}</h3>
        <el-form-item :label="$t('crm.mainContactName')" prop="contactName"
                      :rules="[{ required: true, message: `${$t('common.plzInput')}${$t('crm.mainContactName')}`  }]">
          <el-input v-model="vendorContactsInfoForm.contactName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm.mainContactTitle')" prop="contactTitle"
                      :rules="[{ required: true, message: `${$t('common.plzInput')}${$t('crm.mainContactTitle')}`  }]">
          <el-input v-model="vendorContactsInfoForm.contactTitle"></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm.mainContactReponseSpeed')" prop="contactResponseSpeed"
                      :rules="[{ required: true, message: `${$t('common.plzSelect')}${$t('crm.mainContactReponseSpeed')}`  }]">
          <el-select v-model="vendorContactsInfoForm.contactResponseSpeed">
            <el-option v-for="item in scoreList" :label="item.dictValue" :value="item.dictCode"
                       :key="item.dictCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('crm.mainContactResponsiblefor')" prop="contactResponsibleFor"
                      :rules="[{ required: true, message: `${$t('common.plzSelect')}${$t('crm.mainContactResponsiblefor')}`  }]">
          <el-select v-model="vendorContactsInfoForm.contactResponsibleFor">
            <el-option v-for="item in contactResponsibleFor" :label="item.dictValue" :value="item.dictCode"
                       :key="item.dictCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('crm.mainContactNegotitationStyle')" prop="contactNegotiationStyle">
          <el-input type="textarea" v-model="vendorContactsInfoForm.contactNegotiationStyle" :rows="3"
                    resize="none"></el-input>
        </el-form-item>
        <h3>{{ $t('crm.mainContact') }}</h3>
        <div class="contact-group" v-for="(item, index) in contactFormContactList" :key="index">
          <div class="contact-item">
            <el-form-item class="mb15" :label="$t('crm.formOfCommunication')" :prop="`contactList.${index}.contactType`"
                          :rules="[{ required: true, message: `${$t('common.plzSelect')}${$t('crm.formOfCommunication')}`  }]">
              <el-select v-model="item.contactType">
                <el-option v-for="item in contactInformationType" :label="item.dictValue" :value="item.dictCode"
                           :key="item.dictCode"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="mb15" :label="$t('crm.contactNumber')" :prop="`contactList.${index}.contactNo`"
                          :rules="[{ required: true, message: `${$t('common.plzInput')}${$t('crm.contactNumber')}`  }]">
              <el-input v-model="item.contactNo"></el-input>
            </el-form-item>
          </div>
          <el-button type="text" v-if="contactFormContactList.length > 1" @click="removeContactsItem(item, index)">
            {{ $t('common.remove') }}
          </el-button>
        </div>
        <el-button type="text" @click="addContactsItem">+{{ $t('crm.addContactInfo') }}</el-button>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleVendorContactsInfo = false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="submitVendorContactsInfo">{{ $t('common.ok') }}</el-button>
      </span>
    </el-dialog>

    <h2 class="mt30">{{ $t('crm.visitInfo') }}</h2>
    <el-row :gutter="20">
      <el-col :xs="24" :sm="24" :md="20" :lg="14" :xl="10">
        <el-form :model="ruleForm" label-width="200px">
          <el-form-item :label="$t('crm.quarterlyF2FVisitFrequency')">
            <el-select v-model="ruleForm.vendorExtReqVo.quarterVisitCount">
              <el-option v-for="item in visitCountList" :label="item.dictValue" :value="item.dictCode"
                         :key="item.dictCode"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('crm.otherVisitingFrequency')">
            <el-input v-model="ruleForm.vendorExtReqVo.otherVisitHabit"></el-input>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>

    <h2 class="mt30">{{ $t('crm.retailStore') }}</h2>
    <el-row :gutter="20">
      <el-col :xs="24" :sm="24" :md="20" :lg="14" :xl="10">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm2" label-width="200px">
          <el-form-item :label="$t('crm.hasRetailStore')" prop="vendorExtReqVo.isOfflineStore">
            <el-select v-model="ruleForm.vendorExtReqVo.isOfflineStore">
              <el-option :label="$t('crm.hasRetailStore1')" :value="1"></el-option>
              <el-option :label="$t('crm.hasRetailStore0')" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('crm.retailStoreScale')" v-if="ruleForm.vendorExtReqVo.isOfflineStore === 1">
            <el-input v-model="ruleForm.vendorExtReqVo.offlineStoreDesc"></el-input>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-table :data="retailStoreData2" :header-cell-style="{backgroundColor: '#f0f0f0'}" border
              v-if="ruleForm.vendorExtReqVo.isOfflineStore === 1">
      <el-table-column prop="storeName" :label="$t('crm.retailStoreName')"></el-table-column>
      <el-table-column prop="storeAddress" :label="$t('crm.retailStoreAddress')"></el-table-column>
      <el-table-column prop="storeSinceAt" :label="$t('crm.retailStoreYears')"></el-table-column>
      <el-table-column prop="saleAmountOfYear" :label="$t('crm.retailStoreAnnualSales')"></el-table-column>
      <el-table-column prop="percentage" :label="$t('crm.retailStoreSalesContribution')"></el-table-column>
      <el-table-column :label="$t('common.action')">
        <template slot-scope="scope">
          <el-button type="text" @click="removeRetailStore(scope)" size="mini">{{ $t('common.remove') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-button type="text" @click="showDialogRetailStore" v-if="ruleForm.vendorExtReqVo.isOfflineStore === 1">
      {{ $t('crm.addRetailStore') }}
    </el-button>
    <el-dialog :title="$t('crm.addRetailStore')" :visible.sync="dialogVisibleRetailStore" width="500px"
               :close-on-click-modal="false">
      <el-form :model="retailStoreForm" ref="retailStoreForm" label-width="120px">
        <el-form-item :label="$t('crm.retailStoreName')" prop="storeName"
                      :rules="[{ required: true, message: `${$t('common.plzInput')}${$t('crm.retailStoreName')}`  }]">
          <el-input v-model="retailStoreForm.storeName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm.retailStoreAddress')" prop="storeAddress"
                      :rules="[{ required: true, message: `${$t('common.plzInput')}${$t('crm.retailStoreAddress')}`  }]">
          <el-input v-model="retailStoreForm.storeAddress"></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm.retailStoreYears')" prop="storeSinceAt"
                      :rules="[{ required: true, message: `${$t('common.plzInput')}${$t('crm.retailStoreYears')}`  }]">
          <el-input v-model="retailStoreForm.storeSinceAt"></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm.retailStoreAnnualSales')" prop="saleAmountOfYear"
                      :rules="[{ required: true, message: `${$t('common.plzInput')}${$t('crm.retailStoreAnnualSales')}`  }]">
          <el-input v-model="retailStoreForm.saleAmountOfYear"></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm.retailStoreSalesContribution')" prop="percentage"
                      :rules="[{ required: true, message: `${$t('common.plzInput')}${$t('crm.retailStoreSalesContribution')}`  }]">
          <el-input v-model="retailStoreForm.percentage"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleRetailStore = false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="submitRetailStore">{{ $t('common.ok') }}</el-button>
      </span>
    </el-dialog>

    <h2 class="mt30">{{ $t('crm.otherSalesChannels') }}</h2>
    <el-form :model="ruleForm" ref="ruleForm3" label-width="300px">
      <el-row>
        <el-col class="mb30" :xs="24" :sm="24" :md="12" :lg="11" :xl="10">
          <div class="mb40">
            <el-form-item :label="$t(`crm.${hasChannelMap[ruleForm.saleChannelReqVos[0].channelType]}`)"
                          :prop="`saleChannelReqVos.0.status`">
              <el-select v-model="ruleForm.saleChannelReqVos[0].status" @change="calcCompletionRate">
                <el-option :label="$t('crm.hasRetailStore1')" :value="1"></el-option>
                <el-option :label="$t('crm.hasRetailStore0')" :value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="ruleForm.saleChannelReqVos[0].status"
                          :label="`${$t(`crm.${channelMap[ruleForm.saleChannelReqVos[0].channelType]}`)}${$t('crm.yearsOfOperatation')}`">
              <el-input v-model="ruleForm.saleChannelReqVos[0].sinceAt" @change="calcCompletionRate"></el-input>
            </el-form-item>
            <el-form-item v-if="ruleForm.saleChannelReqVos[0].status"
                          :label="`${$t(`crm.${channelMap[ruleForm.saleChannelReqVos[0].channelType]}`)}${$t('crm.annualSales')}`">
              <el-input v-model="ruleForm.saleChannelReqVos[0].saleAmount" @change="calcCompletionRate"></el-input>
            </el-form-item>
            <el-form-item v-if="ruleForm.saleChannelReqVos[0].status"
                          :label="`${$t(`crm.${channelMap[ruleForm.saleChannelReqVos[0].channelType]}`)}${$t('crm.salesContribution')}`">
              <el-input v-model="ruleForm.saleChannelReqVos[0].percentage" @change="calcCompletionRate"></el-input>
            </el-form-item>
          </div>

          <el-form-item :label="$t(`crm.${hasChannelMap[ruleForm.saleChannelReqVos[2].channelType]}`)"
                        :prop="`saleChannelReqVos.1.status`">
            <el-select v-model="ruleForm.saleChannelReqVos[2].status" @change="calcCompletionRate">
              <el-option :label="$t('crm.hasRetailStore1')" :value="1"></el-option>
              <el-option :label="$t('crm.hasRetailStore0')" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="ruleForm.saleChannelReqVos[2].status"
                        :label="`${$t(`crm.${channelMap[ruleForm.saleChannelReqVos[2].channelType]}`)}${$t('crm.yearsOfOperatation')}`">
            <el-input v-model="ruleForm.saleChannelReqVos[2].sinceAt" @change="calcCompletionRate"></el-input>
          </el-form-item>
          <el-form-item v-if="ruleForm.saleChannelReqVos[2].status"
                        :label="`${$t(`crm.${channelMap[ruleForm.saleChannelReqVos[2].channelType]}`)}${$t('crm.annualSales')}`">
            <el-input v-model="ruleForm.saleChannelReqVos[2].saleAmount" @change="calcCompletionRate"></el-input>
          </el-form-item>
          <el-form-item v-if="ruleForm.saleChannelReqVos[2].status"
                        :label="`${$t(`crm.${channelMap[ruleForm.saleChannelReqVos[2].channelType]}`)}${$t('crm.salesContribution')}`">
            <el-input v-model="ruleForm.saleChannelReqVos[2].percentage" @change="calcCompletionRate"></el-input>
          </el-form-item>
        </el-col>
        <el-col class="mb30" :xs="24" :sm="24" :md="12" :lg="11" :xl="10">
          <div class="mb40">
            <el-form-item :label="$t(`crm.${hasChannelMap[ruleForm.saleChannelReqVos[1].channelType]}`)"
                          :prop="`saleChannelReqVos.1.status`">
              <el-select v-model="ruleForm.saleChannelReqVos[1].status" @change="calcCompletionRate">
                <el-option :label="$t('crm.hasRetailStore1')" :value="1"></el-option>
                <el-option :label="$t('crm.hasRetailStore0')" :value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="ruleForm.saleChannelReqVos[1].status"
                          :label="`${$t(`crm.${channelMap[ruleForm.saleChannelReqVos[1].channelType]}`)}${$t('crm.yearsOfOperatation')}`">
              <el-input v-model="ruleForm.saleChannelReqVos[1].sinceAt" @change="calcCompletionRate"></el-input>
            </el-form-item>
            <el-form-item v-if="ruleForm.saleChannelReqVos[1].status"
                          :label="`${$t(`crm.${channelMap[ruleForm.saleChannelReqVos[1].channelType]}`)}${$t('crm.annualSales')}`">
              <el-input v-model="ruleForm.saleChannelReqVos[1].saleAmount" @change="calcCompletionRate"></el-input>
            </el-form-item>
            <el-form-item v-if="ruleForm.saleChannelReqVos[1].status"
                          :label="`${$t(`crm.${channelMap[ruleForm.saleChannelReqVos[1].channelType]}`)}${$t('crm.salesContribution')}`">
              <el-input v-model="ruleForm.saleChannelReqVos[1].percentage" @change="calcCompletionRate"></el-input>
            </el-form-item>
          </div>

          <el-form-item :label="$t(`crm.${hasChannelMap[ruleForm.saleChannelReqVos[3].channelType]}`)"
                        :prop="`saleChannelReqVos.3.status`">
            <el-select v-model="ruleForm.saleChannelReqVos[3].status" @change="calcCompletionRate">
              <el-option :label="$t('crm.hasRetailStore1')" :value="1"></el-option>
              <el-option :label="$t('crm.hasRetailStore0')" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="ruleForm.saleChannelReqVos[3].status"
                        :label="`${$t(`crm.${channelMap[ruleForm.saleChannelReqVos[3].channelType]}`)}${$t('crm.yearsOfOperatation')}`">
            <el-input v-model="ruleForm.saleChannelReqVos[3].sinceAt" @change="calcCompletionRate"></el-input>
          </el-form-item>
          <el-form-item v-if="ruleForm.saleChannelReqVos[3].status"
                        :label="`${$t(`crm.${channelMap[ruleForm.saleChannelReqVos[3].channelType]}`)}${$t('crm.annualSales')}`">
            <el-input v-model="ruleForm.saleChannelReqVos[3].saleAmount" @change="calcCompletionRate"></el-input>
          </el-form-item>
          <el-form-item v-if="ruleForm.saleChannelReqVos[3].status"
                        :label="`${$t(`crm.${channelMap[ruleForm.saleChannelReqVos[3].channelType]}`)}${$t('crm.salesContribution')}`">
            <el-input v-model="ruleForm.saleChannelReqVos[3].percentage" @change="calcCompletionRate"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-row :gutter="20">
      <el-col :xs="24" :sm="24" :md="20" :lg="14" :xl="10">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm4" label-width="200px">
          <el-form-item :label="$t('crm.sourceOfGoods')">
            <el-checkbox-group v-model="ruleForm.vendorExtReqVo.stockChannel">
              <el-checkbox v-for="(item, index) in stockChannelList" :key="item.dictValue" :label="item.dictCode">
                {{ item.dictValue }}
                <el-input v-if="index === stockChannelList.length - 1"
                          v-model="ruleForm.vendorExtReqVo.otherStockChannel"></el-input>
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item :label="$t('crm.otherSalesChannels2')">
            <el-input v-model="ruleForm.vendorExtReqVo.otherChannel"></el-input>
          </el-form-item>
          <el-form-item :label="$t('crm.mpProfitExpectation')" prop="vendorExtReqVo.mpProfitExpectation">
            <el-input v-model="ruleForm.vendorExtReqVo.mpProfitExpectation"></el-input>
          </el-form-item>
          <el-form-item :label="$t('crm.profitExpectation')" prop="vendorExtReqVo.pfProfitExpectation">
            <el-input v-model="ruleForm.vendorExtReqVo.pfProfitExpectation"></el-input>
          </el-form-item>

          <h2 class="mt30">{{ $t('crm.fulfillment') }}</h2>
          <el-form-item :label="$t('crm.respondSpeedForFulfillmentIssues')" prop="vendorExtReqVo.issuesRespond">
            <el-select v-model="ruleForm.vendorExtReqVo.issuesRespond">
              <el-option v-for="item in scoreList" :label="item.dictValue" :value="item.dictCode"
                         :key="item.dictCode"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>

    <el-dialog :title="$t('crm.copyRelatedStoreInfo')" :visible.sync="dialogVisibleCopy" width="500px">
      <el-form label-width="180px">
        <el-form-item :label="`${$t('crm.parentCompanyName')}(${$t('crm.businessEntityName')}`">
          <el-select v-model="copyForm.crmGroupInfoId" filterable @change="changeGroup">
            <el-option v-for="item in groupByList" :label="item.groupName" :value="item.crmGroupInfoId"
                       :key="item.crmGroupInfoId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('crm.selectVendor')">
          <el-select v-model="copyForm.vendorId">
            <el-option v-for="item in vendorList" :label="showVendorName ? item.vendorName : item.vendorNameAlias"
                      :value="item.vendorId" :key="item.vendorId"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleCopy = false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="submitCopy" :disabled="!copyForm.vendorId">{{
            $t('crm.copyVendor')
          }}</el-button>
      </span>
    </el-dialog>

    <div class="footer-bar">
      <p>{{ $t('crm.infoCompletion') }}：{{ infoCompletion }}% {{
          $t('crm.requiredFieldCompletion')
        }}：{{ requiredFieldCompletion }}%</p>
      <div>
        <el-button type="text" @click="showCopyDialog">{{ $t('crm.copyRelatedStoreInfo') }}</el-button>
        <el-button type="primary" plain @click="submitTemp">{{ $t('crm.tempStorage') }}</el-button>
        <el-button type="primary" :disabled="disabledSubmit" @click="submitAllForm">{{ $t('crm.saveAudit') }} <span
            class="f12">({{ $t('crm.effectiveAfterAudit') }})</span></el-button>
        <el-button @click="closeWindow">{{ $t('crm.cancelEdit') }}</el-button>
      </div>
    </div>


    <el-dialog :visible.sync="holidaySetDialogVisible" width="30%">
      <el-form-item label="注册时间" prop="registerTime">
        <el-date-picker
            clearable
            v-model="registerTime"
            format="yyyy-MM-dd"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="holidaySetDialogVisible = false">保 存</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="configSetDialogVisible" width="50%">
      <el-form :model="configParams" ref="ruleForm" label-width="150px">
        <el-form-item :label="$t('common.email')">
          {{ruleForm.vendorName}} {{$t('crm.changeRequest')}} {{configParams.labelName}}
        </el-form-item>
        <el-form-item :label="$t('crm.vendorName')">
          {{ruleForm.vendorName}}
        </el-form-item>
        <el-form-item :label="$t('crm.former')+configParams.labelName">
          {{configParams.beforeValue}}
        </el-form-item>
        <el-form-item v-if="configParams.updateType=='update_country'"  :label="$t('crm.vendorGeography')">
          <el-select v-model="configParams.afterValue" filterable :placeholder="$t('common.country')">
            <el-option v-for="item in countryList" :key="item.countryCode + item.addressCountryId" :label="item.name" :value="item.addressCountryId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="configParams.updateType === 'update_currency'" :label="$t('crm.currency')">
          <el-select v-model="configParams.afterValue" filterable>
            <el-option v-for="item in unitList" :label="item.fromCountry" :value="item.fromCountry" :key="item.productExchangeRateId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="configParams.updateType === 'update_retail_price_tax'" :label="$t('crm.retailPriceIncludesTax')">
          <el-radio-group v-model="configParams.afterValue">
            <el-radio :label="1">{{ $t('crm.taxIncluded') }}</el-radio>
            <el-radio :label="2">{{ $t('crm.taxExcluded') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="configParams.updateType === 'update_supply_method'" :label="$t('crm.pricingConnectivityMethod')">
          <el-radio-group v-model="configParams.afterValue">
            <el-radio v-for="item in supplyPriceMethod" :label="+item.dictCode" :key="item.dictCode">
              {{ item.dictValue }}
            </el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item v-if="configParams.updateType === 'update_supply_method' && configParams.afterValue == 1" :label="$t('crm.supplyPriceIncludesTax')">
          <el-radio-group v-model="configParams.childValue">
            <el-radio :label="1">{{ $t('crm.taxIncluded') }}</el-radio>
            <el-radio :label="2">{{ $t('crm.taxExcluded') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="configParams.updateType === 'update_supply_method' && configParams.afterValue == 2" :label="$t('crm.provideHangingPrice')">
          <el-radio-group v-model="configParams.childValue">
            <el-radio :label="1">{{ $t('common.yes') }}</el-radio>
            <el-radio :label="2">{{ $t('common.no') }}</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item v-if="configParams.updateType === 'update_supply_price_tax'" :label="$t('crm.supplyPriceIncludesTax')">
          <el-radio-group v-model="configParams.afterValue">
            <el-radio :label="1">{{ $t('crm.taxIncluded') }}</el-radio>
            <el-radio :label="2">{{ $t('crm.taxExcluded') }}</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item v-if="configParams.updateType === 'update_provide_retail_price'" :label="$t('crm.provideHangingPrice')">
          <el-radio-group v-model="configParams.afterValue">
            <el-radio :label="1">{{ $t('common.yes') }}</el-radio>
            <el-radio :label="2">{{ $t('common.no') }}</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item :label=" $t('crm.conductor')">
          {{opreator}}
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="saveConfig()">{{$t('common.save')}}</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="holidaySetDialogVisible" width="30%">
      <el-form-item label="注册时间" prop="registerTime">
        <el-date-picker
            clearable
            v-model="registerTime"
            format="yyyy-MM-dd"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="holidaySetDialogVisible = false">保 存</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="pwdSetDialogVisible" width="35%">
      <el-form :rules="rules" ref="pwdForm" label-width="80px">
        <el-form-item label="新密码" prop="newPass" :rules="[{ required: true, message: '请输入新密码' }]">
          <el-input v-model="newPass"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="savePwd()">保 存</el-button>
      </span>
    </el-dialog>
  </div>

</template>

<script>
import { mapState } from 'vuex';
import {
  getDictList,
  getVendorAuditDetail,
  saveCRMAudit,
  getGroupListByName,
  getVendorByGroupId,
  getVendorAuditShowDetail, queryEmailConfiguration, getEmailContentType, saveConfig, resetPwd, getConfigStatus,
  saveSnapshot,
} from './api';
import {
  getBoutiqueCityList,
  getBusinessRegionList,
  getCountryList, getUnitList, getUserList, getVendorType, queryStockLocation,
  getBoutiqueCountryList,
} from '../../buyershop/cn/api';

export default {
  components: {
  },
  data() {
    return {
      disabledSubmit: false,
      countryListMap: {},
      countryIdMap: {},
      supplyPriceMethodMap: {},
      taxMap: {
        1: this.$t('crm.taxIncluded'),
        2: this.$t('crm.taxExcluded'),
      },
      newPass: '',
      pwdSetDialogVisible: false,
      configSetDialogVisible: false,
      contentTypeList: [],
      timeZoneList: ["GMT+1", "GMT-4", "GMT+8"],
      dialogVisiblePushEmail: false,
      editOrderTime: false,
      input: null,
      holidaySetDialogVisible: false,
      levelList: [],
      registerTime: [],
      vendorList: [],
      paymentMethodList: [],
      paymentTimingList: [],
      scoreList: [],
      countryList: [],
      contactResponsibleFor: [],
      contactInformationType: [],
      contactTypeMap: {},
      contactResponsibleForMap: {},
      scoreListMap: {},
      stockChannelList: [],
      visitCountList: [],
      groupByList: [],
      unitList: [],
      supplyPriceMethod: [],
      vendorTypeList: [],
      boutiqueBdList: [],
      boutiqueBdListMap: {},
      businessRegionList: [],
      vendorOperationType: [],
      ruleForm: {
        mailDefectLevelConfigVos: [],
        mailDefectLevelValueArr: [],
        orderNotificationEmailVos: [],
        vendorName: null,
        vendorConfigurationVo: {
          vendorType: null,
          appUserId: null,
          isPerSale: null,
          isSignSla: null,
          signSlaTime: null,
          boutiqueBdId: null,
          boutiqueBd: null,
          boutiqueBdName: null,
          boutiqueAssistantId: null,
          boutiqueAssistant: null,
          boutiqueAssistantName: null,
          businessRegion: null,
          operationType: null,
          boutiqueAftermarketEmail: [1111, 222, 333],
          mailDefectLevels: null,
          userAppId: null,
          countryCode: null,
          originalPriceUnit: null,
          supplyPriceMethod: null,
          includingTax: null,
          retailPriceIncludingTax: null,
        },
        stockLocationResVos: [],
        vendorExtReqVo: {
          groupName: null,
          imDefinition: null,
          mpSalesSatisfaction: null,
          wholesaleSalesSatisfaction: null,
          drawback: null,
          stockChannel: [],
          otherStockChannel: null,
          otherChannel: null,
          mpProfitExpectation: null,
          pfProfitExpectation: null,
          issuesRespond: null,
          isOfflineStore: null,
          offlineStoreDesc: null,
          quarterVisitCount: null,
          otherVisitHabit: null,
          vendorAsPerfection: null,
          latestConfirmTime: '23:59',
          latestDeliveryDay: '23:59',
          cutOffTime: '16:00',
        },
        paymentInfoReqVo: {
          paymentMethod: null,
          depositAmount: null,
          paymentTiming: null,
          paymentTimingTime: null,
          paymentTimingRemark: null,
          paymentMethodRemark: null,
          settleCurrency:null //店铺币种
        },
        invoiceReqVo: {
          companyName: null,
          businessLicenseNumber: null,
          contactPerson: null,
          contactEmail: null,
          contactPhone: null,
          addressCountryId: null,
          city: null,
          postalCode: null,
          businessLicenseLocation: null,
        },
        saleChannelReqVos: [{
          channelType: 3,
          status: 1,
        },
          {
            channelType: 4,
            status: 1,
          },
          {
            channelType: 2,
            status: 1,
          },
          {
            channelType: 1,
            status: 1,
          }],
      },
      rules: {
        'vendorName': [{
          required: true,
          message: `${this.$t('common.plzInput')}${this.$t('crm.vendorName')}`
        }],
        'vendorConfigurationVo.vendorType': [{
          required: true,
          message: `${this.$t('common.plzSelect')}${this.$t('crm.vendorType')}`
        }],
        'vendorConfigurationVo.operationType': [{
          required: true,
          message: `${this.$t('common.plzSelect')}${this.$t('crm.operationType')}`
        }],
        // 'vendorConfigurationVo.userAppId': [{
        //   required: true,
        //   message: `${this.$t('common.plzInput')}${this.$t('crm.personalSellerIMID')}`
        // }],
        'vendorConfigurationVo.addressCountryId': [{
          required: true,
          message: `${this.$t('common.plzSelect')}${this.$t('crm.vendorGeography')}`
        }],
        'vendorConfigurationVo.originalPriceUnit': [{
          required: true,
        }],
        'vendorConfigurationVo.retailPriceIncludingTax': [{
          required: true,
        }],
        'vendorConfigurationVo.includingTax': [{
          required: true,
        }],
        'vendorConfigurationVo.provideRetailPrice': [{
          required: true,
        }],
        'vendorConfigurationVo.supplyPriceMethod': [{
          required: true,
          message: `${this.$t('common.plzSelect')}${this.$t('crm.pricingConnectivityMethod')}`
        }],
        'vendorConfigurationVo.supplyPriceIncludesTax': [{
          required: true,
        }],
        'vendorConfigurationVo.isPerSale': [{
          required: true,
          message: `${this.$t('common.plzSelect')}${this.$t('crm.preSaleAvailablity')}`
        }],
        'vendorConfigurationVo.isSignSla': [{
          required: true,
        }],
        'vendorConfigurationVo.signSlaTime': [{ required: true, message: `${this.$t('common.plzSelect')}${this.$t('crm.contractTime')}` }],
        'vendorConfigurationVo.boutiqueAssistantId': [{
          required: true,
          message: `${this.$t('common.plzSelect')}${this.$t('crm.imAssistantRepresentative')}`,
        }],
        'vendorConfigurationVo.boutiqueBdId': [{
          required: true,
        }],
        'vendorConfigurationVo.businessRegionId': [{
          required: true,
        }],
        'vendorExtReqVo.groupName': [{
          required: true,
          message: `${this.$t('common.plzInput')}${this.$t('crm.parentCompanyName')}(${this.$t('crm.businessEntityName')}`
        }],

        'vendorExtReqVo.cutOffTime': [{
          required: true,
          message: `${this.$t('common.plzSelect')}${this.$t('crm.deadlineForDay')}`
        }],
        'vendorExtReqVo.latestConfirmDay': [{
          required: true,
          message: `${this.$t('common.plzSelect')}${this.$t('crm.confirmTimeFromMerchant')}`
        }],
        'vendorExtReqVo.latestConfirmTime': [{
          required: true,
          //message: `${this.$t('common.plzSelect')}${this.$t('crm.preSaleAvailablity')}`
        }],
        'vendorExtReqVo.latestDeliveryDay': [{
          required: true,
          message: `${this.$t('common.plzSelect')}${this.$t('crm.shippingDeadline')}`
        }],
        'vendorExtReqVo.latestDeliveryTime': [{
          required: true,
          //message: `${this.$t('common.plzSelect')}${this.$t('crm.preSaleAvailablity')}`
        }],
        'vendorExtReqVo.deliveryTime': [{
          required: true,
          message: `${this.$t('common.plzSelect')}${this.$t('crm.orderShippingDay')}`
        }],

        'paymentInfoReqVo.paymentMethod': [{
          required: true,
          message: `${this.$t('common.plzSelect')}${this.$t('crm.paymentMethod')}`
        }],
        'paymentInfoReqVo.paymentTiming': [{
          required: true,
          message: `${this.$t('common.plzSelect')}${this.$t('crm.paymentTiming')}`
        }, {validator: this.paymentTimingValidator}],
        'paymentInfoReqVo.paymentTimingTime': [{
          required: true,
          message: `${this.$t('common.plzSelect')}${this.$t('crm.settlementCycle')}`
        }],
        // 'vendorExtReqVo.drawback': [{
        //   required: true,
        //   message: `${this.$t('common.plzSelect')}${this.$t('crm.f')}`
        // }],
        // 'vendorExtReqVo.isOfflineStore': [{
        //   required: true,
        //   message: `${this.$t('common.plzSelect')}${this.$t('crm.hasRetailStore')}`
        // }],
        // 'vendorExtReqVo.mpProfitExpectation': [{
        //   required: true,
        //   message: `${this.$t('common.plzInput')}${this.$t('crm.mpProfitExpectation')}`
        // }],
        // 'vendorExtReqVo.pfProfitExpectation': [{
        //   required: true,
        //   message: `${this.$t('common.plzInput')}${this.$t('crm.profitExpectation')}`
        // }],
      },
      payeeInfoData: [],
      dialogVisiblePayeeInfo: false,
      payeeInfoForm: {
        vendorPaymentId: null,
        payeeName: '',
        bankOfName: '',
        bankAccountNo: '',
        swiftCode: '',
        iban: '',
        bankAddress:"",
        payType:1,//付款方式 1:境外付款 2:境内付款'
        idNo:'',
        phoneNum:'',
        defaultOption: 1
      },
      vendorContactsInfoData: [],
      dialogVisibleVendorContactsInfo: false,
      vendorContactsInfoForm: {
        vendorContactsId: null,
        contactName: '',
        contactTitle: '',
        contactResponseSpeed: '',
        contactResponsibleFor: null,
        contactNegotiationStyle: '',
        contactList: [{
          contactType: null,
          contactNo: '',
          enabled: true,
        }],
      },
      retailStoreData: [],
      dialogVisibleRetailStore: false,
      retailStoreForm: {
        storeName: '',
        storeAddress: '',
        storeSinceAt: null,
        saleAmountOfYear: null,
        percentage: null,
      },
      hasChannelMap: {
        1: 'hasEcWebsite',
        2: 'hasWholesaleBusiness',
        3: 'hasFarfetch',
        4: 'hasDewu',
      },
      channelMap: {
        1: 'ecWebsite',
        2: 'wholesaleBusiness',
        3: 'farfetch',
        4: 'dewu',
      },
      weekMap: {
        Sunday: 1,
        Monday: 2,
        Tuesday: 3,
        Wednesday: 4,
        Thursday: 5,
        Friday: 6,
        Saturday: 7
      },
      weekList: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      dialogVisibleCopy: false,
      copyForm: {
        crmGroupInfoId: null,
        vendorId: null,
      },
      infoCompletion: 0,
      requiredFieldCompletion: 0,
      cityList: [],
      cityList2: [],
      activeName: null,
      comboList: [],
      comboMap: {},
      addContactList: [],
      currEditIndex: null,
      isEditEmail: false,
      addContactValue: null,
      orderTimeList: [],
      currTimeZone: null,
      weekStart: null,
      weekEnd: null,
      timeStart: '00:00',
      timeEnd: '23:59',
      configParams: {
        beforeValue: null,
        afterValue: null,
        updateType: null,
        labelName: null,
        vendorId: null,
        childValue: null,
        childName: null
      },
      opreator: null,
      update_country: true,
      update_currency: true,
      update_retail_price_tax: true,
      update_supply_method: true,
      update_supply_price_tax: true,
      emailContentMap: {},
      cityLoading: false,
      invoiceRequired: false, // 发票是否必填
    };
  },
  computed: {
    payeeInfoData2() {
      return this.payeeInfoData.map((item, index) => {
        item.originIndex = index;
        return item;
      }).filter((item) => item.enabled);
    },
    vendorContactsInfoData2() {
      return this.vendorContactsInfoData.map((item, index) => {
        item.originIndex = index;
        return item;
      }).filter((item) => item.enabled);
    },
    contactFormContactList() {
      return this.vendorContactsInfoForm.contactList.filter((item) => item.enabled);
    },
    retailStoreData2() {
      return this.retailStoreData.map((item, index) => {
        item.originIndex = index;
        return item;
      }).filter((item) => item.enabled);
    },
    orderNotificationEmailVos2() {
      return this.ruleForm.orderNotificationEmailVos.map((item, index) => {
        item.originIndex = index;
        return item;
      }).filter((item) => item.enabled);
    },
    disabledAddStocklocation() {
      return this.ruleForm.stockLocationResVos.some(item => item.editFormStatus)
    },
    ...mapState({
      showVendorName: (state) => state.app.menuMap['商家CRM-hide-查看买手店名称'],
    })
  },
  watch: {
    'ruleForm.vendorExtReqVo.groupName': 'calcCompletionRate',
    'ruleForm.vendorExtReqVo.imDefinition': 'calcCompletionRate',
    'ruleForm.vendorExtReqVo.mpSalesSatisfaction': 'calcCompletionRate',
    'ruleForm.vendorExtReqVo.wholesaleSalesSatisfaction': 'calcCompletionRate',
    'ruleForm.paymentInfoReqVo.paymentMethod': 'calcCompletionRate',
    'ruleForm.paymentInfoReqVo.depositAmount': 'calcCompletionRate',
    'ruleForm.paymentInfoReqVo.paymentTiming': 'calcCompletionRate',
    'ruleForm.paymentInfoReqVo.paymentTimingRemark': 'calcCompletionRate',
    'ruleForm.paymentInfoReqVo.paymentMethodRemark': 'calcCompletionRate',
    'ruleForm.paymentInfoReqVo.settleCurrency': 'calcCompletionRate',
    // 'ruleForm.vendorExtReqVo.drawback': 'calcCompletionRate',
    'ruleForm.invoiceReqVo.companyName': 'calcCompletionRate',
    'ruleForm.invoiceReqVo.businessLicenseNumber': 'calcCompletionRate',
    'ruleForm.invoiceReqVo.contactPerson': 'calcCompletionRate',
    'ruleForm.invoiceReqVo.contactEmail': 'calcCompletionRate',
    'ruleForm.invoiceReqVo.contactPhone': 'calcCompletionRate',
    'ruleForm.invoiceReqVo.addressCountryId': 'calcCompletionRate',
    'ruleForm.invoiceReqVo.city': 'calcCompletionRate',
    'ruleForm.invoiceReqVo.postalCode': 'calcCompletionRate',
    'ruleForm.invoiceReqVo.businessLicenseLocation': 'calcCompletionRate',
    payeeInfoData2: 'calcCompletionRate',
    vendorContactsInfoData2: 'calcCompletionRate',
    'ruleForm.vendorExtReqVo.quarterVisitCount': 'calcCompletionRate',
    'ruleForm.vendorExtReqVo.otherVisitHabit': 'calcCompletionRate',
    'ruleForm.vendorExtReqVo.isOfflineStore': 'calcCompletionRate',
    'ruleForm.vendorExtReqVo.offlineStoreDesc': 'calcCompletionRate',
    retailStoreData2: 'calcCompletionRate',
    'ruleForm.vendorExtReqVo.stockChannel': 'calcCompletionRate',
    'ruleForm.vendorExtReqVo.otherChannel': 'calcCompletionRate',
    'ruleForm.vendorExtReqVo.mpProfitExpectation': 'calcCompletionRate',
    'ruleForm.vendorExtReqVo.pfProfitExpectation': 'calcCompletionRate',
    'ruleForm.vendorExtReqVo.issuesRespond': 'calcCompletionRate',
  },
  created() {
    this._currEditIndex = null;
  },
  mounted() {
    this.init();
    this.getVendorAuditDetail(this.$route.params.id);
  },
  methods: {
    init() {
      getUnitList().then(res => {
        if (res.data) {
          this.unitList = res.data.data;
        }
      });
      getConfigStatus({
        vendorId: this.$route.params.id
      }).then(res => {
        if (res.data && res.data.success) {
          this.update_country =res.data.data.find(element=>element.code == 'update_country')?true:false;
          this.update_currency =res.data.data.find(element=>element.code == 'update_currency')?true:false;
          this.update_retail_price_tax =res.data.data.find(element=>element.code == 'update_retail_price_tax')?true:false;
          this.update_supply_method =res.data.data.find(element=>element.code == 'update_supply_method')?true:false;
          this.update_supply_price_tax =res.data.data.find(element=>element.code == 'update_supply_price_tax')?true: false;
          this.update_provide_retail_price =res.data.data.find(element=>element.code == 'update_provide_retail_price')?true: false;
        }
      });
      getDictList({
        parentCode: 'ticket_notification_email',
      }).then(res => {
        if (res.data && res.data.success) {
          this.opreator = res.data.data[0].dictValue || '';
        }
      });
      queryStockLocation({
        vendorId: this.$route.params.id
      }).then(res => {
        if (res.data && res.data.data) {
          const map = { '-1': 'self' };
          this.comboList = res.data.data.map((item) => {
            map[item.locationId] = item.stockLocation;
            if (item.state === 2) {
              item.disabled = true;
            }
            return item;
          });
          this.comboMap = map;
        }
      })
      getEmailContentType().then(res => {
        if (res.data && res.data.success) {
          this.contentTypeList = (res.data.data || []).map(item => ({
            code: item.code,
            explain: item.explain,
            checked: true,
          }));
          const map = {};
          (res.data.data || []).forEach(item => {
            map[item.code] = item.explain;
          })
          this.emailContentMap = map;

        }
      })
      getDictList({
        parentCode: 'vendor_operation_type',
      }).then(res => {
        if (res.data && res.data.success) {
          this.vendorOperationType = res.data.data.filter(item => {
            return item.dictCode !== '9' && item.dictCode !== '17'
          }) || [];
        }
      });
      getBusinessRegionList().then(res => {
        if (res.data) {
          this.businessRegionList = (res.data.data || []).filter(item => {
            // 过滤奥莱村 寄售 识季测试业务
            return item.businessRegionId !== 8 && item.businessRegionId !== 11 && item.businessRegionId !== 12
          }).map(item => ({
            label: item.businessRegionName,
            value: item.businessRegionId,
          }));
        }
      });
      getUserList().then(res => {
        const map = {};
        this.boutiqueBdList = (res.data || []).map(item => {
          map[item.deptUserId] = item.deptUserName;
          return {
            label: item.deptUserName,
            value: item.deptUserId,
          };
        });
        this.boutiqueBdListMap = map;
      });
      getVendorType().then(res => {
        if (res.data) {
          this.vendorTypeList = res.data.data;
        }
      });
      getDictList({
        parentCode: 'supply_price_method',
      }).then(res => {
        if (res.data && res.data.success) {
          this.supplyPriceMethod = res.data.data || [];
          const map = {};
          (res.data.data || []).forEach(item => {
            map[item.dictCode] = item.dictValue;
          })
          this.supplyPriceMethodMap = map;
        }
      });
      getGroupListByName({
        groupName: '',
      }).then(res => {
        if (res.data && res.data.success) {
          this.groupByList = res.data.data;
        }
      })
      getDictList({
        parentCode: 'crm_score',
      }).then(res => {
        if (res.data && res.data.success) {
          this.scoreList = res.data.data || [];
          const map = {};
          (res.data.data || []).forEach(item => {
            map[item.dictCode] = item.dictValue;
          })
          this.scoreListMap = map;
        }
      });
      getDictList({
        parentCode: 'crm_payment_method',
      }).then(res => {
        if (res.data && res.data.success) {
          this.paymentMethodList = res.data.data || [];
        }
      });
      getDictList({
        parentCode: 'crm_payment_timing',
      }).then(res => {
        if (res.data && res.data.success) {
          this.paymentTimingList = res.data.data || [];
        }
      });
      getDictList({
        parentCode: 'contact_responsible_for',
      }).then(res => {
        if (res.data && res.data.success) {
          this.contactResponsibleFor = res.data.data || [];
          const map = {};
          (res.data.data || []).forEach(item => {
            map[item.dictCode] = item.dictValue;
          })
          this.contactResponsibleForMap = map;
        }
      });
      getDictList({
        parentCode: 'contact_information_type',
      }).then(res => {
        if (res.data && res.data.success) {
          this.contactInformationType = res.data.data || [];
          const map = {};
          (res.data.data || []).forEach(item => {
            map[item.dictCode] = item.dictValue;
          })
          this.contactTypeMap = map;
        }
      });
      getDictList({
        parentCode: 'crm_stock_channel',
      }).then(res => {
        if (res.data && res.data.success) {
          this.stockChannelList = res.data.data || [];
        }
      });
      getDictList({
        parentCode: 'quarter_visit_count',
      }).then(res => {
        if (res.data && res.data.success) {
          this.visitCountList = res.data.data || [];
        }
      });
      getBoutiqueCountryList().then(res => {
        if (res.data) {
          const map = {};
          const map2 = {};
          this.countryList = (res.data.data || []).map(item => {
            map[item.countryCode] = item.name;
            map2[item.addressCountryId] = item.name;
            return item;
          }).filter(item => {
            if (item.addressCountryId != 100) {
              return true;
            }
            return false;
          });
          this.countryIdMap = map2;
          this.countryListMap = map;
        }
      });
      queryEmailConfiguration().then(res => {
        if (res.data && res.data.success) {
          this.levelList = (res.data.data || []).map(item => ({
            //autoSendFlag: false,
            labelName: item,
          }));
        }
        console.info(this.levelList,'+++')
      });
    },
    getVendorAuditDetail(vendorId, isCopy) {
      const vendorNameBak = this.ruleForm.vendorName;
      getVendorAuditDetail({
        vendorId,
      }).then(res => {
        if (res.data && res.data.success && res.data.data) {
          this.invoiceRequired = res.data.data.invoiceRequired;
          if (res.data.data.vendorConfigurationVo.vendorType == 1) {
            this.invoiceRequired = false;
          }
          res.data.data.vendorExtReqVo.stockChannel = res.data.data.vendorExtReqVo.stockChannel || [];
          res.data.data.saleChannelReqVos = res.data.data.saleChannelReqVos || [];
          res.data.data.invoiceReqVo.vendorId = this.$route.params.id;
          res.data.data.paymentInfoReqVo.vendorId = this.$route.params.id;
          res.data.data.saleChannelReqVos = res.data.data.saleChannelReqVos.map(item => {
            item.vendorId = this.$route.params.id;
            return item;
          });
          res.data.data.vendorExtReqVo.vendorId = this.$route.params.id;
          res.data.data.vendorId = this.$route.params.id;
          if (isCopy) {
            res.data.data.vendorName = vendorNameBak;
            res.data.data.receivePaymentReqVos = res.data.data.receivePaymentReqVos || [];
            res.data.data.vendorContacts = res.data.data.vendorContacts || [];
            res.data.data.offlineStoreReqVos = res.data.data.offlineStoreReqVos || [];
            res.data.data.receivePaymentReqVos = res.data.data.receivePaymentReqVos.map((item => {
              delete item.vendorPaymentId;
              return item;
            })).filter((item => {
              return item.enabled !== false;
            }))
            res.data.data.vendorContacts = res.data.data.vendorContacts.map((item => {
              delete item.vendorContactsId;
              item.contactList = item.contactList.map(sitem => {
                delete sitem.contactId;
                return sitem;
              }).filter((sitem => {
                return sitem.enabled !== false;
              }))
              return item;
            })).filter((item => {
              return item.enabled !== false;
            }))
            res.data.data.offlineStoreReqVos = res.data.data.offlineStoreReqVos.map((item => {
              delete item.crmVendorOfflineStoreId;
              return item;
            })).filter((item => {
              return item.enabled !== false;
            }))
            this.payeeInfoDataOld = this.payeeInfoDataOld.map((item) => {
              item.enabled = false;
              return item;
            }).filter((item => {
              return item.vendorPaymentId;
            }));
            this.vendorContactsInfoDataOld = this.vendorContactsInfoDataOld.map((item) => {
              item.enabled = false;
              return item;
            }).filter((item => {
              return item.vendorContactsId;
            }));
            this.retailStoreDataOld = this.retailStoreDataOld.map((item) => {
              item.enabled = false;
              return item;
            }).filter((item => {
              return item.crmVendorOfflineStoreId;
            }));
            this.payeeInfoData = [...this.payeeInfoDataOld, ...res.data.data.receivePaymentReqVos];
            this.vendorContactsInfoData = [...this.vendorContactsInfoDataOld, ...res.data.data.vendorContacts];
            this.retailStoreData = [...this.retailStoreDataOld, ...res.data.data.offlineStoreReqVos];
          } else {
            this.payeeInfoData = res.data.data.receivePaymentReqVos || [];
            this.vendorContactsInfoData = res.data.data.vendorContacts || [];
            this.retailStoreData = res.data.data.offlineStoreReqVos || [];
            this.payeeInfoDataOld = JSON.parse(JSON.stringify(res.data.data.receivePaymentReqVos || []));
            this.vendorContactsInfoDataOld = JSON.parse(JSON.stringify(res.data.data.vendorContacts || []));
            this.retailStoreDataOld = JSON.parse(JSON.stringify(res.data.data.offlineStoreReqVos || []));
          }
          res.data.data.stockLocationResVos = res.data.data.stockLocationResVos.map((item, index) => ({
            ...item,
            editFormStatus: false,
            key: index
          }))
          this.stockLocationCurrKey = res.data.data.stockLocationResVos.length - 1;
          res.data.data.mailDefectLevelValueArr = [];
          res.data.data.mailDefectLevelConfigVos.forEach(item => {
            res.data.data.mailDefectLevelValueArr.push(item.levelCode)
          })
          res.data.data.orderNotificationEmailVos = res.data.data.orderNotificationEmailVos.map(item => ({
            ...item,
            orderTime: JSON.parse(item.orderTime),
          }))
          res.data.data.vendorConfigurationVo.operationType = res.data.data.vendorConfigurationVo.operationType ? res.data.data.vendorConfigurationVo.operationType + '' : '';
          this.ruleForm = res.data.data;
          if (this.$route.params.re && !isCopy) {
            getVendorAuditShowDetail({
              vendorId,
              status: 2,
            }).then(res => {
              if (res.data && res.data.success && res.data.data) {
                try {
                  const data = JSON.parse(res.data.data.modifyContentAfter);
                  this.payeeInfoData = data.receivePaymentReqVos || [];
                  this.payeeInfoDataOld = JSON.parse(JSON.stringify(data.receivePaymentReqVos || []));
                  this.ruleForm.paymentInfoReqVo = JSON.parse(JSON.stringify(data.paymentInfoReqVo || []));
                } catch (error) {
                  console.log("error",error)
                  this.$message.error(this.$t('common.systemError'));
                }
              }
            })
          }

        }
      });

    },
    changePaymentMethod() {
      this.$refs.ruleForm.clearValidate('paymentInfoReqVo.depositAmount');
    },
    calcCompletionRate() {
      let total = 29;
      let requiredTotal = 14; // 不计算 母公司名 前面的字段
      let fillCount = 0;
      let requiredCount = 0;
      if (this.ruleForm.paymentInfoReqVo.paymentMethod === 'crm_pre_payment') {
        requiredTotal += 1;
      }
      if (this.ruleForm.paymentInfoReqVo.paymentTiming === 'crm_payment_others') {
        total += 1;
        requiredTotal += 1;
      }
      if (!this.invoiceRequired) {
        requiredTotal -= 9;
      }
      if (this.ruleForm.vendorExtReqVo.isOfflineStore !== 1) {
        total -= 2;
      }
      (this.ruleForm.saleChannelReqVos || []).forEach(item => {
        if (item.status) {
          total += 4;
        } else {
          total += 1;
        }
      })
      if (this.ruleForm.vendorExtReqVo.groupName) {
        fillCount += 1;
        requiredCount += 1;
      }
      if (this.ruleForm.vendorExtReqVo.imDefinition) {
        fillCount += 1;
      }
      if (this.ruleForm.vendorExtReqVo.mpSalesSatisfaction) {
        fillCount += 1;
      }
      if (this.ruleForm.vendorExtReqVo.wholesaleSalesSatisfaction) {
        fillCount += 1;
      }
      if (this.ruleForm.paymentInfoReqVo.paymentMethod) {
        fillCount += 1;
        requiredCount += 1;
      }
      if (this.ruleForm.paymentInfoReqVo.depositAmount) {
        fillCount += 1;
      }
      if (this.ruleForm.paymentInfoReqVo.paymentMethod === 'crm_pre_payment' && this.ruleForm.paymentInfoReqVo.depositAmount) {
        requiredCount += 1;
      }
      if (this.ruleForm.paymentInfoReqVo.paymentTiming) {
        fillCount += 1;
        requiredCount += 1;
      }
      if (this.ruleForm.paymentInfoReqVo.paymentTiming === 'crm_payment_others' && this.ruleForm.paymentInfoReqVo.paymentTimingRemark) {
        fillCount += 1;
        requiredCount += 1;
      }
      if (this.ruleForm.paymentInfoReqVo.paymentMethodRemark) {
        fillCount += 1;
      }
      if (this.ruleForm.paymentInfoReqVo.settleCurrency) {
        fillCount += 1;
      }
      // if (this.ruleForm.vendorExtReqVo.drawback || this.ruleForm.vendorExtReqVo.drawback === 0) {
      //   fillCount += 1;
      //   requiredCount += 1;
      // }
      if (this.ruleForm.invoiceReqVo.companyName) {
        if (this.invoiceRequired) {
          requiredCount += 1;
        }
        fillCount += 1;
      }
      if (this.ruleForm.invoiceReqVo.businessLicenseNumber) {
        if (this.invoiceRequired) {
          requiredCount += 1;
        }
        fillCount += 1;
      }
      if (this.ruleForm.invoiceReqVo.contactPerson) {
        if (this.invoiceRequired) {
          requiredCount += 1;
        }
        fillCount += 1;
      }
      if (this.ruleForm.invoiceReqVo.contactEmail) {
        if (this.invoiceRequired) {
          requiredCount += 1;
        }
        fillCount += 1;
      }
      if (this.ruleForm.invoiceReqVo.contactPhone) {
        if (this.invoiceRequired) {
          requiredCount += 1;
        }
        fillCount += 1;
      }
      if (this.ruleForm.invoiceReqVo.addressCountryId) {
        if (this.invoiceRequired) {
          requiredCount += 1;
        }
        fillCount += 1;
      }
      if (this.ruleForm.invoiceReqVo.city) {
        if (this.invoiceRequired) {
          requiredCount += 1;
        }
        fillCount += 1;
      }
      if (this.ruleForm.invoiceReqVo.postalCode) {
        if (this.invoiceRequired) {
          requiredCount += 1;
        }
        fillCount += 1;
      }
      if (this.ruleForm.invoiceReqVo.businessLicenseLocation) {
        if (this.invoiceRequired) {
          requiredCount += 1;
        }
        fillCount += 1;
      }
      if (this.payeeInfoData2.length > 0) {
        fillCount += 1;
        requiredCount += 1;
      }
      if (this.vendorContactsInfoData2.length > 0) {
        fillCount += 1;
        requiredCount += 1;
      }
      if (this.ruleForm.vendorExtReqVo.quarterVisitCount) {
        fillCount += 1;
      }
      if (this.ruleForm.vendorExtReqVo.otherVisitHabit) {
        fillCount += 1;
      }
      if (this.ruleForm.vendorExtReqVo.isOfflineStore || this.ruleForm.vendorExtReqVo.isOfflineStore === 0) {
        fillCount += 1;
      }
      if (this.ruleForm.vendorExtReqVo.isOfflineStore === 1 && this.ruleForm.vendorExtReqVo.offlineStoreDesc) {
        fillCount += 1;
      }
      if (this.ruleForm.vendorExtReqVo.isOfflineStore === 1 && this.retailStoreData2.length > 0) {
        fillCount += 1;
      }
      (this.ruleForm.saleChannelReqVos || []).forEach(item => {
        if (item.status || item.status === 0) {
          fillCount += 1;
        }
        if (item.status && item.sinceAt) {
          fillCount += 1;
        }
        if (item.status && item.saleAmount) {
          fillCount += 1;
        }
        if (item.status && item.percentage) {
          fillCount += 1;
        }
      });
      if (this.ruleForm.vendorExtReqVo.stockChannel.length > 0) {
        fillCount += 1;
      }
      if (this.ruleForm.vendorExtReqVo.otherChannel) {
        fillCount += 1;
      }
      if (this.ruleForm.vendorExtReqVo.mpProfitExpectation) {
        fillCount += 1;
      }
      if (this.ruleForm.vendorExtReqVo.pfProfitExpectation) {
        fillCount += 1;
      }
      if (this.ruleForm.vendorExtReqVo.issuesRespond) {
        fillCount += 1;
      }
      this.infoCompletion = Math.floor(fillCount / total * 100);
      this.requiredFieldCompletion = Math.floor(requiredCount / requiredTotal * 100);

      this.ruleForm.vendorExtReqVo.vendorAsPerfection = this.infoCompletion / 100;
    },
    changePaymentTiming() {
      if (this.ruleForm.paymentInfoReqVo.paymentTiming !== 'crm_payment_others') {
        this.ruleForm.paymentInfoReqVo.paymentTimingRemark = '';
      }
      if (this.ruleForm.paymentInfoReqVo.paymentTiming !== 'crm_payment_week') {
        this.ruleForm.paymentInfoReqVo.paymentTimingTime = null;
      }
    },
    paymentTimingValidator(rule, value, callback) {
      if (value === 'crm_payment_others' && !this.ruleForm.paymentInfoReqVo.paymentTimingRemark) {
        callback(new Error(this.$t('crm.otherPaymentTiming')));
      } else {
        callback();
      }
    },
    querySearch(queryString, cb) {
      let restaurants = this.groupByList;
      let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.groupName.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    editPayeeInfo(scope) {
      console.error(scope,'scope---');
      // debugger
      this._currEditIndex = scope.row.originIndex;
      this.payeeInfoForm.vendorPaymentId = scope.row.vendorPaymentId;
      this.payeeInfoForm.payeeName = scope.row.payeeName;
      this.payeeInfoForm.bankOfName = scope.row.bankOfName;
      this.payeeInfoForm.bankAccountNo = scope.row.bankAccountNo;
      this.payeeInfoForm.bankAddress = scope.row.bankAddress;
      this.payeeInfoForm.swiftCode = scope.row.swiftCode;
      this.payeeInfoForm.iban = scope.row.iban;
      this.payeeInfoForm.payType = scope.row.payType;
      this.payeeInfoForm.idNo = scope.row.idNo;
      this.payeeInfoForm.phoneNum = scope.row.phoneNum;
      this.payeeInfoForm.defaultOption = scope.row.defaultOption;
      this.dialogVisiblePayeeInfo = true;
      this.$nextTick(() => {
        this.$refs.payeeInfoForm.clearValidate();
      })
    },
    removePayeeInfo(scope) {
      if (scope.row.vendorPaymentId) {
        this.payeeInfoData[scope.row.originIndex].enabled = false;
      } else {
        this.payeeInfoData.splice(scope.row.originIndex, 1);
      }
    },
    showDialogPayeeInfo() {
      this._currEditIndex = null;
      this.payeeInfoForm.vendorPaymentId = null;
      this.payeeInfoForm.payeeName = null;
      this.payeeInfoForm.bankOfName = null;
      this.payeeInfoForm.bankAccountNo = null;
      this.payeeInfoForm.bankAddress = null;
      this.payeeInfoForm.swiftCode = null;
      this.payeeInfoForm.iban = null;
      this.payeeInfoForm.payType = 1;//默认付款方式
      this.payeeInfoForm.idNo = null;
      this.payeeInfoForm.phoneNum = null;
      this.payeeInfoForm.defaultOption = 1;
      this.dialogVisiblePayeeInfo = true;
      this.$nextTick(() => {
        this.$refs.payeeInfoForm.clearValidate();
      })
    },
    submitPayeeInfo() {
      const that = this;
      this.$refs.payeeInfoForm.validate((vali) => {
        if (vali) {
          this.dialogVisiblePayeeInfo = false;
          if (that._currEditIndex != null) {
            this.payeeInfoData[that._currEditIndex].payeeName = that.payeeInfoForm.payeeName;
            this.payeeInfoData[that._currEditIndex].bankOfName = that.payeeInfoForm.bankOfName;
            this.payeeInfoData[that._currEditIndex].bankAccountNo = that.payeeInfoForm.bankAccountNo;
            this.payeeInfoData[that._currEditIndex].bankAddress = that.payeeInfoForm.bankAddress;
            this.payeeInfoData[that._currEditIndex].swiftCode = that.payeeInfoForm.swiftCode;
            this.payeeInfoData[that._currEditIndex].iban = that.payeeInfoForm.iban;
            this.payeeInfoData[that._currEditIndex].payType = that.payeeInfoForm.payType;
            this.payeeInfoData[that._currEditIndex].idNo = that.payeeInfoForm.idNo;
            this.payeeInfoData[that._currEditIndex].phoneNum = that.payeeInfoForm.phoneNum;
            this.payeeInfoData[that._currEditIndex].defaultOption = that.payeeInfoForm.defaultOption;
          } else {
            that.payeeInfoData.push({
              ...this.payeeInfoForm,
              enabled: true,
            });
          }
        }
      })
    },
    editVendorContactsInfo(scope) {
      this._currEditIndex = scope.row.originIndex;
      const data = {
        vendorContactsId: scope.row.vendorContactsId,
        contactName: scope.row.contactName,
        contactTitle: scope.row.contactTitle,
        contactResponseSpeed: scope.row.contactResponseSpeed,
        contactResponsibleFor: scope.row.contactResponsibleFor,
        contactNegotiationStyle: scope.row.contactNegotiationStyle,
      };
      if (scope.row.contactList) {
        if (scope.row.contactList.some(item => item.enabled)) {
          data.contactList = scope.row.contactList;
        } else {
          data.contactList = [...scope.row.contactList, {
            contactType: null,
            contactNo: '',
            enabled: true,
          }];
        }
      } else {
        data.contactList = [{
          contactType: null,
          contactNo: '',
          enabled: true,
        }];
      }
      this.vendorContactsInfoForm = data;
      this.dialogVisibleVendorContactsInfo = true;
      this.$nextTick(() => {
        this.$refs.vendorContactsInfoForm.clearValidate();
      });
    },
    removeVendorContactsInfo(scope) {
      this.$confirm(`<span style="color:red">${this.$t('crm.needAddedAfterDel')}</span>${this.$t('crm.doYouContinue')}`, this.$t('crm.sureDelContact'), {
        confirmButtonText: this.$t('common.ok'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning',
        dangerouslyUseHTMLString: true,
      }).then(() => {
        if (scope.row.vendorContactsId) {
          this.vendorContactsInfoData[scope.row.originIndex].enabled = false;
        } else {
          this.vendorContactsInfoData.splice(scope.row.originIndex, 1);
        }
      }).catch(() => {
      });
    },
    showVendorContactsInfo() {
      this._currEditIndex = null;
      this.dialogVisibleVendorContactsInfo = true;
      this.vendorContactsInfoForm = {
        contactName: '',
        contactTitle: '',
        contactResponseSpeed: '',
        contactResponsibleFor: null,
        contactNegotiationStyle: '',
        contactList: [{
          contactType: null,
          contactNo: '',
          enabled: true,
        }],
      };
      this.$nextTick(() => {
        this.$refs.vendorContactsInfoForm.clearValidate();
      });
    },
    submitVendorContactsInfo() {
      const that = this;
      this.$refs.vendorContactsInfoForm.validate((vali) => {
        if (vali) {
          this.dialogVisibleVendorContactsInfo = false;
          if (this._currEditIndex != null) {
            this.vendorContactsInfoData[that._currEditIndex].contactName = this.vendorContactsInfoForm.contactName;
            this.vendorContactsInfoData[that._currEditIndex].contactTitle = this.vendorContactsInfoForm.contactTitle;
            this.vendorContactsInfoData[that._currEditIndex].contactResponseSpeed = this.vendorContactsInfoForm.contactResponseSpeed;
            this.vendorContactsInfoData[that._currEditIndex].contactResponsibleFor = this.vendorContactsInfoForm.contactResponsibleFor;
            this.vendorContactsInfoData[that._currEditIndex].contactNegotiationStyle = this.vendorContactsInfoForm.contactNegotiationStyle;
            this.vendorContactsInfoData[that._currEditIndex].contactList = this.vendorContactsInfoForm.contactList;
          } else {
            this.vendorContactsInfoData.push({
              ...this.vendorContactsInfoForm,
              enabled: true,
            });
          }
        }
      })
    },
    removeContactsItem(item, index) {
      if (item.contactId) {
        this.vendorContactsInfoForm.contactList[index].enabled = false;
      } else {
        this.vendorContactsInfoForm.contactList.splice(index, 1);
      }
    },
    addContactsItem() {
      this.vendorContactsInfoForm.contactList.push({
        contactType: null,
        contactNo: '',
        enabled: true,
      });
    },
    removeRetailStore(scope) {
      if (scope.row.crmVendorOfflineStoreId) {
        this.retailStoreData[scope.row.originIndex].enabled = false;
      } else {
        this.retailStoreData.splice(scope.row.originIndex, 1);
      }
    },
    showDialogRetailStore() {
      this.dialogVisibleRetailStore = true;
      this.$nextTick(() => {
        this.$refs.retailStoreForm.resetFields();
      });
    },
    submitRetailStore() {
      const that = this;
      this.$refs.retailStoreForm.validate((vali) => {
        if (vali) {
          this.dialogVisibleRetailStore = false;
          that.retailStoreData.push({
            ...this.retailStoreForm,
            enabled: true,
          });
        }
      })
    },
    showCopyDialog() {
      this.copyForm.crmGroupInfoId = null;
      this.copyForm.vendorId = null;
      this.dialogVisibleCopy = true;
    },
    changeGroup() {
      this.vendorList = [];
      this.copyForm.vendorId = null;
      getVendorByGroupId({groupId: this.copyForm.crmGroupInfoId}).then(res => {
        if (res.data && res.data.success) {
          this.vendorList = res.data.data || [];
        }
      });
    },
    submitCopy() {
      this.getVendorAuditDetail(this.copyForm.vendorId, true);
      this.dialogVisibleCopy = false;
    },
    submitTemp() {
      const orderNotificationEmailVos = this.ruleForm.orderNotificationEmailVos.map(item=>{
        return{
          ...item,
          orderTime: JSON.stringify(item.orderTime),
          vendorId: this.$route.params.id,
        }
      });
      const mailDefectLevelConfigVos = this.ruleForm.mailDefectLevelValueArr.map(item=>{
        return {
          levelCode: item,
          sendFlag: 1,
          enabled: true,
          vendorId: this.$route.params.id,
          mailDefectLevelId: '',
        }
      });
      saveSnapshot({
        ...this.ruleForm,
        orderNotificationEmailVos,
        stockLocationResVos: this.ruleForm.stockLocationResVos.map((item) => {
          return {
            ...item,
            vendorId: this.$route.params.id,
          }
        }),
        mailDefectLevelConfigVos,
        receivePaymentReqVos: this.payeeInfoData.map((item) => {
          return {
            ...item,
            vendorId: this.$route.params.id,
          }
        }),
        vendorContacts: this.vendorContactsInfoData.map((item) => {
          return {
            ...item,
            vendorId: this.$route.params.id,
          }
        }),
        offlineStoreReqVos: this.retailStoreData.map((item) => {
          return {
            ...item,
            vendorId: this.$route.params.id,
          }
        }),
      }).then(res => {
        if (res.data && res.data.success) {
          this.$router.push({
            path: '/crm/cn/list',
          });
        } else {
          this.$message.error(res.data.message || this.$t('common.systemError'));
          // this.getVendorAuditDetail(this.$route.params.id);
        }
      });
    },
    async submitAllForm() {
      this.disabledSubmit = true;
      try {
        await this.$refs.ruleForm.validate();
        let editKey = '';
        if (this.ruleForm.stockLocationResVos.some(item => {
          if (item.editFormStatus) {
            editKey = item.key;
            return true;
          }
          return false;
        })) {
          await this.$refs['form' + editKey][0].validate();
        }
        await this.$refs.ruleForm11.validate();
        await this.$refs.ruleForm2.validate();
        await this.$refs.ruleForm3.validate();
        await this.$refs.ruleForm4.validate();

        if (this.payeeInfoData2.length === 0) {
          this.$message(this.$t('common.plzAdd') + this.$t('crm.payeeInfo'));
          this.disabledSubmit = false;
          return;
        }

        const orderNotificationEmailVos = this.ruleForm.orderNotificationEmailVos.map(item=>{
          return{
            ...item,
            orderTime: JSON.stringify(item.orderTime),
            vendorId: this.$route.params.id,
          }
        });
        console.log('mailDefectLevelValueArr', this.ruleForm.mailDefectLevelValueArr);
        const mailDefectLevelConfigVos = this.ruleForm.mailDefectLevelValueArr.map(item=>{
          return {
            levelCode: item,
            sendFlag: 1,
            enabled: true,
            vendorId: this.$route.params.id,
            mailDefectLevelId: '',
          }
        });
        // delete this.ruleForm.mailDefectLevelValueArr
        saveCRMAudit({
          ...this.ruleForm,
          orderNotificationEmailVos,
          stockLocationResVos: this.ruleForm.stockLocationResVos.map((item) => {
            return {
              ...item,
              vendorId: this.$route.params.id,
            }
          }),
          mailDefectLevelConfigVos,
          receivePaymentReqVos: this.payeeInfoData.map((item) => {
            return {
              ...item,
              vendorId: this.$route.params.id,
            }
          }),
          vendorContacts: this.vendorContactsInfoData.map((item) => {
            return {
              ...item,
              vendorId: this.$route.params.id,
            }
          }),
          offlineStoreReqVos: this.retailStoreData.map((item) => {
            return {
              ...item,
              vendorId: this.$route.params.id,
            }
          }),
        }).then(res => {
          if (res.data && res.data.success) {
            this.$message.success(this.$t('common.submitSuccess'));
            this.$router.push({
              path: '/crm/cn/list',
            });
            this.getVendorAuditDetail(this.$route.params.id);
          } else {
            this.$message.error(res.data.message || this.$t('common.systemError'));
            // this.getVendorAuditDetail(this.$route.params.id);
          }
          this.disabledSubmit = false;
        })
      } catch (error) {
        console.log(error);
        this.$message(this.$t('common.fullFormTip'));
        this.disabledSubmit = false;
        //this.getVendorAuditDetail(this.$route.params.id);
      }
    },
    validateEmail(email) {
      const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return regex.test(email);
    },
    submitEmail() {
      if (!this.validateEmail(this.input)){
        this.$message.error("请输入有效的邮箱格式！");
        return;
      }
      this.ruleForm.vendorConfigurationVo.boutiqueAftermarketEmail.push(this.input);
      this.input = null;
    },
    onClickRemove(item) {
      let i = this.ruleForm.vendorConfigurationVo.boutiqueAftermarketEmail.indexOf(item)
      this.ruleForm.vendorConfigurationVo.boutiqueAftermarketEmail.splice(i, 1)
    },
    remoteMethod(query, item) {
      this.cityLoading = true;
      getBoutiqueCityList({
        countryId: item.aaaCountryId,
        cityCode: query,
      }).then(res => {
        if (res.data && res.data.data) {
          this.cityList = res.data.data;
        }
        this.cityLoading = false;
      })
    },
    onClickAdd() {
      if (!this.ruleForm.stockLocationResVos.some(item => item.editFormStatus)) {
        this.stockLocationCurrKey++;
        this.ruleForm.stockLocationResVos.unshift({
          locationId: null,
          addressCity: "",
          addressCountryCode: "",
          addressPostalCode: "",
          addressStreetlines: "",
          areaCode: "",
          contactCompanyName: "",
          contactEmailAddress: "",
          contactPersonName: "",
          contactPhoneNumber: "",
          countryName: "",
          fullAddress: "",
          shipFromLocationId: null,
          state: 1,
          stockLocation: "",
          addCountryId: null,
          editFormStatus: true,
          isAdd: true,
          enabled: true,
          vendorId: this.$route.params.id,
          key: this.stockLocationCurrKey,
        });
        this.activeName = 'collapse' + this.stockLocationCurrKey;
        this.$nextTick(() => {
          this.$refs[`form${this.stockLocationCurrKey}`][0].clearValidate();
        })
      } else {
        this.activeName = null;
      }
    },
    onchangeCountry(item, init) {
      this.countryList.filter(c => {
        if (c.countryCode === item.addressCountryCode) {
          item.aaaCountryId = c.addressCountryId;
          item.areaCode = c.areaCode;
          return true;
        }
        return false;
      })
      if (!init) {
        item.addressCity = null;
        this.cityList = [];
      }
      this.remoteMethod('', item);
    },
    update(item) {
      if (item.addressCountryCode && this.getCountryRegex(item.addressCountryCode)) {
        const regex = this.getCountryRegex(item.addressCountryCode);
        if (!regex.test(item.addressPostalCode)) {
          this.$message.error(this.$t('crm.incorrectPostalCodeFormat'));
          return;
        }
      }
      this.$refs['form' + item.key][0].validate((valid) => {
        if (valid) {
          this.activeName = null;
          item.editFormStatus = false;
        }
      })
    },
    create(item) {
      if (item.addressCountryCode && this.getCountryRegex(item.addressCountryCode)) {
        const regex = this.getCountryRegex(item.addressCountryCode);
        if (!regex.test(item.addressPostalCode)) {
          this.$message.error(this.$t('crm.incorrectPostalCodeFormat'));
          return;
        }
      }
      this.$refs['form' + item.key][0].validate((valid) => {
        if (valid) {
          this.activeName = null;
          item.editFormStatus = false;
        }
      })
    },
    clickEdit(e, item) {
      if (this.activeName === 'collapse' + item.key) {
        e.stopPropagation();
      }
      this.editStockLocationBak = JSON.parse(JSON.stringify(item));
      item.editFormStatus = true;
      this.onchangeCountry(item, true);
    },
    setState(item, state) {
      item.state = state;
    },
    onClickCancel(index) {
      this.ruleForm.stockLocationResVos[index].stockLocation = this.editStockLocationBak.stockLocation;
      this.ruleForm.stockLocationResVos[index].shipFromLocationId = this.editStockLocationBak.shipFromLocationId;
      this.ruleForm.stockLocationResVos[index].contactCompanyName = this.editStockLocationBak.contactCompanyName;
      this.ruleForm.stockLocationResVos[index].contactPersonName = this.editStockLocationBak.contactPersonName;
      this.ruleForm.stockLocationResVos[index].contactEmailAddress = this.editStockLocationBak.contactEmailAddress;
      this.ruleForm.stockLocationResVos[index].areaCode = this.editStockLocationBak.areaCode;
      this.ruleForm.stockLocationResVos[index].contactPhoneNumber = this.editStockLocationBak.contactPhoneNumber;
      this.ruleForm.stockLocationResVos[index].addressCountryCode = this.editStockLocationBak.addressCountryCode;
      this.ruleForm.stockLocationResVos[index].addressCity = this.editStockLocationBak.addressCity;
      this.ruleForm.stockLocationResVos[index].addressPostalCode = this.editStockLocationBak.addressPostalCode;
      this.ruleForm.stockLocationResVos[index].addressStreetlines = this.editStockLocationBak.addressStreetlines;
      this.ruleForm.stockLocationResVos[index].addressStreetlines2 = this.editStockLocationBak.addressStreetlines2;
      this.ruleForm.stockLocationResVos[index].addressStreetlines3 = this.editStockLocationBak.addressStreetlines3;
      this.ruleForm.stockLocationResVos[index].editFormStatus = false;
      this.stockLocationErrorFlag = false;
    },
    editPushEmail(scope) {
      const item = scope.row;
      this.currEditIndex = scope.$index;
      this.isEditEmail = true;

      this.addContactValue = "";
      this.addContactList = item.email.split(",");

      this.orderTimeList = [];
      const orderTime = item.orderTime;
      orderTime.forEach((ot, i) => {
        this.orderTimeList.push({
          startTime: ot.startTime,
          endTime: ot.endTime,
          id: i,
          content: ot.startTime + " ~ " + ot.endTime
        });
      });

      this.currTimeZone = item.timeZone;

      let ids = item.emailContent.split(",");
      this.contentTypeList.forEach(ct => {
        ct.checked = false;

        ids.forEach(id => {
          if (id == ct.code) {
            ct.checked = true;
          }
        });
      });

      this.dialogVisiblePushEmail = true;
    },
    removePushEmail(scope) {
      if (scope.row.id) {
        this.ruleForm.orderNotificationEmailVos[scope.row.originIndex].enabled = false;
      } else {
        this.ruleForm.orderNotificationEmailVos.splice(scope.$index, 1);
      }
    },
    addPushEmail() {
      this.isEditEmail = false;

      this.addContactValue = "";
      this.addContactList = [];
      this.orderTimeList = [];
      this.contentTypeList.forEach(ct => {
        ct.checked = true;
      });

      this.orderTimeList = [];
      this.addContactList = [];
      this.currTimeZone = null;

      this.dialogVisiblePushEmail = true;
    },
    addContact() {
      if (this.addContactValue === "") {
        this.$message('email can not null');
        return;
      }
      let reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!reg.test(this.addContactValue)) {
        this.$message('Incorrect mailbox format');
        return;
      }
      if (this.addContactList.indexOf(this.addContactValue) > -1) {
        this.$message('mail cannot be repeated');
        return;
      }
      this.addContactList.push(this.addContactValue);
      this.addContactValue = "";
    },
    removeContact(item) {
      let index = this.addContactList.indexOf(item);
      if (index > -1) {
        this.addContactList.splice(index, 1);
      }
    },
    deleteOrderList(index) {
      this.orderTimeList.splice(index, 1);
    },
    submitPushEmail() {
      if (this.addContactValue && this.addContactList.length < 10) {
        this.addContact();
      }
      if (this.addContactList.length == 0) {
        this.$message('Please add email');
        return false;
      }
      if (this.orderTimeList.length == 0) {
        this.$message('Please add order time');
        return false;
      }
      if (!this.currTimeZone && this.currTimeZone != 0) {
        this.$message('Please select time zone');
        return false;
      }
      const ids = [];
      const emailContentArr = [];
      this.contentTypeList.forEach(ct => {
        if (ct.checked) {
          ids.push(ct.code);
          emailContentArr.push(ct.explain);
        }
      });
      if (ids.length == 0) {
        this.$message('Please select the email content');
        return false;
      }
      let otList = [];
      this.orderTimeList.forEach(ot => {
        otList.push({
          startTime: ot.startTime,
          endTime: ot.endTime
        });
      });
      let params = {
        email: this.addContactList.join(","),
        orderTime: otList,
        timeZone: this.currTimeZone,
        emailContent: ids.join(","),
        emailContentStr: emailContentArr.join(','),
        vendorId: this.$route.query.vendorId,
        enabled: true,
      };
      if (this.isEditEmail) {
        console.info(132)
        this.ruleForm.orderNotificationEmailVos[this.currEditIndex].email = params.email;
        this.ruleForm.orderNotificationEmailVos[this.currEditIndex].orderTime = params.orderTime;
        this.ruleForm.orderNotificationEmailVos[this.currEditIndex].timeZone = params.timeZone;
        this.ruleForm.orderNotificationEmailVos[this.currEditIndex].emailContent = params.emailContent;
        this.ruleForm.orderNotificationEmailVos[this.currEditIndex].emailContentStr = params.emailContentStr;
        this.ruleForm.orderNotificationEmailVos[this.currEditIndex].vendorId = params.vendorId;
        this.dialogVisiblePushEmail = false;
      } else {
        this.ruleForm.orderNotificationEmailVos.push(params);
        this.dialogVisiblePushEmail = false;
      }
    },
    saveTimeZone() {
      if (
          !this.weekStart ||
          !this.weekEnd ||
          !this.timeStart ||
          !this.timeEnd
      ) {
        this.$message('Please select all time');
        return;
      }
      if (this.weekMap[this.weekStart] > this.weekMap[this.weekEnd]) {
        this.$message('The latter time must be greater than the previous time');
        return;
      } else if (this.weekStart == this.weekEnd) {
        if (this.timeStart > this.timeEnd) {
          this.$message('The latter time must be greater than the previous time');
          return;
        } else if (this.timeStart == this.timeEnd && this.timeStart >= this.timeEnd) {
          this.$message('The latter time must be greater than the previous time');
          return;
        }
      }

      //开始时间2
      const currws2 = this.weekMap[this.weekStart];
      const currts2 = this.timeStart;
      const currstart2 = currws2 + currts2;
      //结束时间2
      const currwe2 = this.weekMap[this.weekEnd];
      const currte2 = this.timeEnd;
      const currend2 = currwe2 + currte2;

      for (let i = 0; i < this.orderTimeList.length; i++) {
        //开始时间1
        const st1 = this.orderTimeList[i].startTime;
        const ws1 = this.weekMap[st1.split(" ")[0]];
        const ts1 = st1.split(" ")[1];
        const start1 = ws1 + ts1;
        //结束时间1
        const st2 = this.orderTimeList[i].endTime;
        const we1 = this.weekMap[st2.split(" ")[0]];
        const te1 = st2.split(" ")[1];
        const end1 = we1 + te1;

        if (!(currend2 <= start1 || currstart2 >= end1)) {
          this.$message('order time cannot overlap');
          return;
        }
      }

      this.orderTimeList.push({
        id: Date.now(),
        content:
            this.weekStart + " " + currts2 + " ~ " + this.weekEnd + " " + currte2,
        startTime: this.weekStart + " " + currts2,
        endTime: this.weekEnd + " " + currte2
      });
      this.editOrderTime = false;
    },
    sendEmail(updateType, labelName){
      this.configParams.updateType = updateType;
      this.configParams.labelName = labelName;
      this.configParams.vendorId = this.$route.params.id
      this.configParams.afterValue = '';
      this.configParams.childName = '';
      this.configParams.childValue = '';

      if(this.configParams.updateType=='update_country'){
        this.configParams.beforeValue = this.countryIdMap[this.ruleForm.vendorConfigurationVo.addressCountryId]
      }else if(this.configParams.updateType=='update_currency'){
        this.configParams.beforeValue = this.ruleForm.vendorConfigurationVo.originalPriceUnit
      }else if(this.configParams.updateType=='update_retail_price_tax'){
        this.configParams.beforeValue = this.taxMap[this.ruleForm.vendorConfigurationVo.retailPriceIncludingTax]
      }else if(this.configParams.updateType=='update_supply_method'){
        this.configParams.beforeValue = this.supplyPriceMethodMap[this.ruleForm.vendorConfigurationVo.supplyPriceMethod]
      }else if(this.configParams.updateType=='update_supply_price_tax'){
        this.configParams.beforeValue = this.taxMap[this.ruleForm.vendorConfigurationVo.includingTax]
      }else if(this.configParams.updateType=='update_provide_retail_price'){
        this.configParams.beforeValue = this.ruleForm.vendorConfigurationVo.provideRetailPrice == 1 ? this.$t('common.yes') : this.$t('common.no');
      }

      this.configSetDialogVisible = true;
    },
    saveConfig() {
      if(this.configParams.updateType=='update_country'){
        this.configParams.beforeValue = this.countryIdMap[this.ruleForm.vendorConfigurationVo.addressCountryId]
        this.configParams.afterValue = this.countryIdMap[this.configParams.afterValue]
      }else if(this.configParams.updateType=='update_currency'){
        this.configParams.beforeValue = this.ruleForm.vendorConfigurationVo.originalPriceUnit
      }else if(this.configParams.updateType=='update_retail_price_tax'){
        this.configParams.beforeValue = this.taxMap[this.ruleForm.vendorConfigurationVo.retailPriceIncludingTax]
        this.configParams.afterValue = this.taxMap[this.configParams.afterValue]
      }else if(this.configParams.updateType=='update_supply_method'){
        if(this.configParams.afterValue == '1') {
          this.configParams.childName = '供货价是否含税';
          this.configParams.childValue = this.configParams.childValue == 1 ? '含税': '不含税'
        } else if (this.configParams.afterValue == '2') {
          this.configParams.childName = '是否提供吊牌价';
          this.configParams.childValue = this.configParams.childValue == 1 ? '是': '否'
        }
        this.configParams.beforeValue = this.supplyPriceMethodMap[this.ruleForm.vendorConfigurationVo.supplyPriceMethod]
        this.configParams.afterValue = this.supplyPriceMethodMap[this.configParams.afterValue]

      }else if(this.configParams.updateType=='update_supply_price_tax'){
        this.configParams.beforeValue = this.taxMap[this.ruleForm.vendorConfigurationVo.includingTax]
        this.configParams.afterValue = this.taxMap[this.configParams.afterValue]
      }else if(this.configParams.updateType=='update_provide_retail_price') {
        this.configParams.beforeValue = this.ruleForm.vendorConfigurationVo.provideRetailPrice == 1 ? this.$t('common.yes') : this.$t('common.no');
        this.configParams.afterValue = this.configParams.afterValue == 1 ? this.$t('common.yes') : this.$t('common.no');
      }
      saveConfig({
        ...this.configParams,
      }).then(res => {
        console.info(res.data, '//=//')
        if (res && res.data.success) {
          this.$message.success('发送成功');
          this.configSetDialogVisible = false;
          this.init()
        } else {
        }
      })
    },
    savePwd(){
      resetPwd({
        vendorId: this.$route.params.id,
        newPass: this.newPass
      }).then(res => {
        if(res.data&&res.data){
          this.$message.success('重置成功');
          this.pwdSetDialogVisible = false
        }else {
          this.pwdSetDialogVisible = false
        }
      })
    },
    emailContentMapFnc(_){
      let emailContentArr = [];
      if(_&&_.length) {
        _ = _.split(',')
      }
      _.map(item=>{
        emailContentArr.push(this.emailContentMap[item])
      })
      return emailContentArr.toString();
    },
    changeCheckList(e) {
      this.$forceUpdate();
    },
    remoteMethod2(query) {
      this.cityLoading = true;
      getBoutiqueCityList({
        countryId: this.ruleForm.invoiceReqVo.addressCountryId,
        cityCode: query,
      }).then(res => {
        if (res.data && res.data.data) {
          this.cityList2 = res.data.data;
        }
        this.cityLoading = false;
      })
    },
    changeBoutiqueBdId() {
      this.ruleForm.vendorConfigurationVo.boutiqueBd = this.boutiqueBdListMap[this.ruleForm.vendorConfigurationVo.boutiqueBdId];
      this.ruleForm.vendorConfigurationVo.boutiqueBdName = this.ruleForm.vendorConfigurationVo.boutiqueBd;
    },
    changeBoutiqueAssistantId() {
      this.ruleForm.vendorConfigurationVo.boutiqueAssistant = this.boutiqueBdListMap[this.ruleForm.vendorConfigurationVo.boutiqueAssistantId];
      this.ruleForm.vendorConfigurationVo.boutiqueAssistantName = this.ruleForm.vendorConfigurationVo.boutiqueAssistant;
    },
    getCountryRegex(code) {
      if ("PK" === code) {
        return /^[0-9]{5}$/;
      } else if ("CN" === code) {
        return /^[0-9]{6}$/;
      } else if ("HK" === code) {
        return null;
      } else if ("MO" === code) {
        return null;
      } else if ("AT" === code) {
        return /^[0-9]{4}$/;
      } else if ("BE" === code) {
        return /^[0-9]{4}$/;
      } else if ("BG" === code) {
        return /^[0-9]{4}$/;
      } else if ("HR" === code) {
        return /^[0-9]{5}$/;
      } else if ("CY" === code) {
        return /^[0-9]{4}$/;
      } else if ("CZ" === code) {
        return /^[0-9]{5}$/;
      } else if ("DK" === code) {
        return /^[0-9]{4}$/;
      } else if ("EE" === code) {
        return /^[0-9]{5}$/;
      } else if ("FI" === code) {
        return /^[0-9]{5}$/;
      } else if ("FR" === code) {
        return /^[0-9]{5}$/;
      } else if ("DE" === code) {
        return /^[0-9]{5}$/;
      } else if ("GR" === code) {
        return /^[0-9]{5}$/;
      } else if ("HU" === code) {
        return /^[0-9]{4}$/;
      } else if ("IE" === code) {
        return null;
      } else if ("IT" === code) {
        return /^[0-9]{5}$/;
      } else if ("LV" === code) {
        return /^[0-9]{4}$/;
      } else if ("LT" === code) {
        return /^[0-9]{5}$/;
      } else if ("LU" === code) {
        return /^[0-9]{4}$/;
      } else if ("MT" === code) {
        return null;
      } else if ("NL" === code) {
        return /^[0-9]{4}$/;
      } else if ("PL" === code) {
        return /^[0-9]{5}$/;
      } else if ("PT" === code) {
        return /^[0-9]{7}$/;
      } else if ("RO" === code) {
        return /^[0-9]{6}$/;
      } else if ("SK" === code) {
        return /^[0-9]{5}$/;
      } else if ("SI" === code) {
        return /^[0-9]{4}$/;
      } else if ("ES" === code) {
        return /^[0-9]{5}$/;
      } else if ("SE" === code) {
        return /^[0-9]{5}$/;
      } else if ("GB" === code) {
        return /^[0-9a-zA-Z]+$/;
      } else if ("US" === code) {
        return /^[0-9]{5}$/;
      } else if ("RU" === code) {
        return /^[0-9]{6}$/;
      } else if ("CA" === code) {
        return /^[0-9a-zA-Z]+$/;
      } else if ("AU" === code) {
        return /^[0-9]{3,4}$/;
      } else if ("NZ" === code) {
        return /^[0-9]{4}$/;
      } else if ("TW" === code) {
        return /^[0-9]{3,5}$/;
      } else if ("PH" === code) {
        return /^[0-9]{4}$/;
      } else if ("KR" === code) {
        return /^[0-9]{5}$/;
      } else if ("MY" === code) {
        return /^[0-9]{5}$/;
      } else if ("JP" === code) {
        return /^[0-9]{7}$/;
      } else if ("TH" === code) {
        return /^[0-9]{5}$/;
      } else if ("SG" === code) {
        return /^[0-9]{6}$/;
      }
      return null;
    },
    closeWindow() {
      window.close();
    },
    checkAddressLength(rule, value, callback, item) {
      if (`${item.addressStreetLines}${item.addressStreetLines2}${item.addressStreetLines3}`.length > 100) {
        callback(new Error(`${this.$t('common.address')}1${this.$t('common.address')}2${this.$t('common.address')}3${this.$t('common.tooLong')}`));
      } else {
        callback();
      }
    },
    onInputAddress(ref) {
      this.$refs[ref][0].validateField('addressStreetLines');
    },
    changeBusinessRegionId(val) {
      // 1 Europe   2 New Marketing   5 Italy
      if (this.ruleForm.vendorConfigurationVo.vendorType != 1) {
        if (val === 1 || val === 2 || val === 5) {
          this.invoiceRequired = true;
        } else {
          this.invoiceRequired = false;
          this.$refs.ruleForm11.clearValidate('invoiceReqVo.companyName');
          this.$refs.ruleForm11.clearValidate('invoiceReqVo.businessLicenseNumber');
        }
      }
      if (val != 5) {
        this.ruleForm.vendorConfigurationVo.boutiqueAssistantTwo = null;
        this.ruleForm.vendorConfigurationVo.boutiqueAssistantTwoName = null;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.handling {
  color: #dec674;
  font-size: 14px;
}
.buyerShop {
  position: relative;
  padding: 20px 20px 100px 20px;

  .footer-bar {
    position: fixed;
    right: 20px;
    bottom: 0;
    left: 210px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    padding: 0 20px;
    transition: left 0.3s;
    background-color: #fff;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
    border-radius: 10px 10px 0 0;
    z-index: 10;
  }
}

.stock-location {
  max-width: 1000px;
}

.form-btn {
  margin-top: 40px;
}

.f12 {
  font-size: 12px;
}

.mt10 {
  margin-top: 10px;
}

.mt20 {
  margin-top: 20px;
}

.mt30 {
  margin-top: 50px;
}

.mb5 {
  margin-bottom: 5px;
}

.mb10 {
  margin-bottom: 10px;
}

.mb15 {
  margin-bottom: 15px;
}

.mb20 {
  margin-bottom: 20px;
}

.mb30 {
  margin-bottom: 30px;
}

.mb40 {
  margin-bottom: 40px;
}

.tr {
  text-align: right;
}

h2 {
  padding-bottom: 10px;
  margin-bottom: 20px;
  border-bottom: 2px solid #DCDFE6;
}

.contact-group {
  display: flex;
  align-items: center;
  padding-top: 10px;
  margin-top: 10px;
  background-color: #f8f8f8;

  .contact-item {
    margin-right: 20px;
  }
}

.btn-group {
  float: right;
}

.email {
  max-width: 1000px;
}

.mt10 {
  margin-top: 10px;
}

.mb20 {
  margin-bottom: 20px;
}

.area-mobile {
  position: relative;
  padding-left: 65px;

  .area-code {
    position: absolute;
    top: 1px;
    left: 0;
    width: 65px;
  }
}

.email-item {
  position: relative;
  display: inline-block;
  padding: 0 30px 0 10px;
  margin: 0 15px 15px 0;
  line-height: 30px;
  border: 1px solid #ccc;
  border-radius: 30px;

  .icon-close {
    position: absolute;
    top: 0;
    right: 0;
    width: 30px;
    height: 30px;
    font-size: 16px;
    text-align: center;
    line-height: 30px;
    cursor: pointer;

    &:hover {
      color: #409EFF;
    }
  }
}
.send-email{
  color: #409EFF;
  cursor: pointer;
  display: inline-block;
}

.title {
  flex: 1;
  display: flex;

  .id {
    min-width: 100px;
  }

  .name {
    min-width: 200px;
  }

  .status {
    flex: 1;
  }

  .right {
    margin-right: 20px;
  }
}

.mb10 {
  margin-bottom: 10px;
}

.form {
  padding-left: 20px;
}

.tr {
  text-align: right;
}

.area-mobile {
  position: relative;
  padding-left: 65px;

  .area-code {
    position: absolute;
    top: 1px;
    left: 0;
    width: 65px;
  }
}
</style>
